"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[1150],{

/***/ 41392:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66226);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47361);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31978);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85808);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24113);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10430);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39682);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71462);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52493);
/* harmony import */ var pages_catalog_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63985);
/* harmony import */ var pages_catalog_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57434);









const ActivePersonalityTags = (param)=>{
    let { catalogueName, isEcommerce } = param;
    const { appliedFilters, availableFilters, isFetchingFilters } = (0,pages_catalog_util__WEBPACK_IMPORTED_MODULE_2__/* .useCatalogueContext */ .J)();
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const appliedTagIds = appliedFilters?.TAGS;
    const availableTags = availableFilters?.TAGS;
    const groups = (0,pages_catalog_util__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        availableTags,
        appliedTagIds,
        catalogueName
    });
    if (isFetchingFilters) {
        return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: "mt-16 flex",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    w: 120,
                    h: 120
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: "mx-8",
                    w: 120,
                    h: 120
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    w: 120,
                    h: 120
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: "mt-32 grid grid-cols-5 gap-16",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    pw: 100,
                    h: 128
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    pw: 100,
                    h: 128
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    pw: 100,
                    h: 128
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    pw: 100,
                    h: 128
                })
            ]
        });
    }
    if (!groups?.length) {
        return null;
    }
    const handleClick = (name, index)=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Personalization tag category select", {
            position: index + 1,
            tagCategory: name
        });
        (0,modals__WEBPACK_IMPORTED_MODULE_8__/* .openModal */ .h7)("personalityTagsModal", {
            sectionToScroll: name,
            keepSortAndFilters: isEcommerce
        });
    };
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: groups.map((param, index)=>{
            let { name, image } = param;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_inputs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "text-center",
                onClick: ()=>handleClick(name, index),
                "data-testid": "openActivePersonalityButton",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        className: "w-full",
                        aspect: isMobile ? 1 : 214 / 128,
                        fit: "cover",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: "rounded",
                            src: image,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: isMobile ? "mt-8 text-p4" : "mt-12 text-p2",
                        children: name
                    })
                ]
            }, name);
        })
    });
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: "mt-16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid gap-8 grid-flow-col w-min auto-cols-[120rem]",
                    children: content
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "mt-32 grid grid-cols-5 gap-16",
        children: content
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ActivePersonalityTags);


/***/ }),

/***/ 65714:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ CatalogContextProvider)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/router/Redirect.tsx
var Redirect = __webpack_require__(68964);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(7362);
// EXTERNAL MODULE: ./src/components/layout/WhitePageLayout/WhitePageLayout.tsx
var WhitePageLayout = __webpack_require__(63208);
// EXTERNAL MODULE: ./src/compositions/PageSkeleton/PageSkeleton.tsx
var PageSkeleton = __webpack_require__(69886);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@growthbook+growthbook-react@0.21.0_react@18.2.0/node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(34020);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/actions/scrollToElement.ts
var scrollToElement = __webpack_require__(4570);
// EXTERNAL MODULE: ./src/helpers/devicePx.ts
var devicePx = __webpack_require__(48073);
// EXTERNAL MODULE: ./src/modules/collaborations/useCollaborationProducts.ts
var useCollaborationProducts = __webpack_require__(28724);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(69219);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(61420);
;// CONCATENATED MODULE: ./src/pages/catalog/util/graph/catalogueFilters.graphql.ts
const CatalogueFiltersDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CatalogueFilters"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "catalogueId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Long"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "catalogue"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "catalogueId"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "catalogueId"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "catalogueTreeKey"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "appType"
                                                        },
                                                        "value": {
                                                            "kind": "EnumValue",
                                                            "value": "WEB"
                                                        }
                                                    },
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "treeName"
                                                        },
                                                        "value": {
                                                            "kind": "StringValue",
                                                            "value": "MainCatalog",
                                                            "block": false
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "availableFilters"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "title"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "filterType"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "filterSelectionType"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "values"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "image"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "rebrandImage"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "popular"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "group"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
CatalogueFiltersDocument["definitions"] = [
    ...new Set(CatalogueFiltersDocument.definitions)
];
/* harmony default export */ const catalogueFilters_graphql = (CatalogueFiltersDocument);

// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
;// CONCATENATED MODULE: ./src/pages/catalog/util/messages.ts
/* harmony default export */ const messages = ({
    categories: {
        title: {
            en: "Filter By Catalogue"
        },
        theShopCandles: {
            en: "Candles"
        },
        theShopCandleWickTrimmer: {
            en: "Candle Wick Trimmer"
        },
        theShopDiffusers: {
            en: "Diffusers"
        },
        theShopIncense: {
            en: "Incense"
        },
        theShopDeodorants: {
            en: "Deodorant"
        },
        theShopLotionsAndOils: {
            en: "Lotions & Oils"
        },
        theShopBodyAndHairMist: {
            en: "Body Mist & Hair Mist"
        },
        theShopBathAndShowerGel: {
            en: "Bath & Shower Gel"
        },
        theShopHandSanitizer: {
            en: "Hand Sanitizer"
        }
    },
    collaborations: {
        scentbirdSelect: {
            en: "Scentbird Select"
        }
    },
    labels: {
        new: {
            en: "New!"
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/util/useCollaborationsFilters.ts






const CATALOGUES_WITH_COLLABORATIONS = [
    "colognes",
    "perfumes"
];
const useCollaborationsFilters = (catalogueName)=>{
    const isSaksCollaborationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    const intl = (0,useIntl/* default */.Z)();
    const areCollaborationsFiltersAvailable = CATALOGUES_WITH_COLLABORATIONS.includes(catalogueName);
    const filters = (0,react.useMemo)(()=>{
        if (!areCollaborationsFiltersAvailable) {
            return null;
        }
        const values = [];
        if (isSaksCollaborationEnabled) {
            values.push({
                group: "",
                id: "scentbirdSelect",
                image: "",
                label: intl.formatMessage(messages.labels.new),
                name: intl.formatMessage(messages.collaborations.scentbirdSelect),
                popular: false,
                rebrandImage: ""
            });
        }
        if (!values.length) {
            return null;
        }
        return [
            {
                filterSelectionType: "SINGLE",
                filterType: "COLLABORATION",
                id: "collaboration",
                title: "",
                values
            }
        ];
    }, [
        areCollaborationsFiltersAvailable,
        intl,
        isSaksCollaborationEnabled
    ]);
    return {
        filters: filters || []
    };
};
/* harmony default export */ const util_useCollaborationsFilters = (useCollaborationsFilters);

// EXTERNAL MODULE: ./src/modules/products/useAvailableCatalogues.ts + 1 modules
var useAvailableCatalogues = __webpack_require__(33286);
;// CONCATENATED MODULE: ./src/pages/catalog/util/useTheShopCatalogueFilters.ts






const THE_SHOP_IGNORED_CATALOGUES = [
    "theShopAllBathAndBody",
    "theShopAllCandlesHomeScents"
];
const THE_SHOP_ROOT_CATALOGUES_MAP = {
    theShopAllBathAndBody: "theShopBathAndBody",
    theShopAllCandlesHomeScents: "theShopCandlesHomeScents"
};
const useTheShopCatalogueFilters = (catalogueName)=>{
    const isTheShopEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theShop);
    const intl = (0,useIntl/* default */.Z)();
    const rootCatalogueName = isTheShopEnabled ? THE_SHOP_ROOT_CATALOGUES_MAP[catalogueName] : null;
    const { availableCatalogues, isFetching } = (0,useAvailableCatalogues/* default */.Z)({
        catalogueName: rootCatalogueName,
        excludeCatalogues: THE_SHOP_IGNORED_CATALOGUES,
        skip: !rootCatalogueName
    });
    const filters = (0,react.useMemo)(()=>{
        const catalogues = availableCatalogues?.map((catalogue)=>{
            const { id, name } = catalogue;
            return {
                group: "",
                id: id.toString(),
                image: "",
                name: intl.formatMessage(messages.categories[name]),
                popular: false,
                rebrandImage: ""
            };
        });
        if (!catalogues) {
            return null;
        }
        return [
            {
                filterSelectionType: "SINGLE",
                filterType: "CATALOGUE",
                id: "catalogue",
                title: intl.formatMessage(messages.categories.title),
                values: catalogues
            }
        ];
    }, [
        availableCatalogues,
        intl
    ]);
    return {
        filters: filters || [],
        isFetching
    };
};
/* harmony default export */ const util_useTheShopCatalogueFilters = (useTheShopCatalogueFilters);

;// CONCATENATED MODULE: ./src/pages/catalog/util/useAvailableFilters.ts





const useAvailableFilters = (catalogueId, catalogueName)=>{
    const { data, isFetching: isFetchingFilters } = (0,useQuery/* default */.Z)(catalogueFilters_graphql, {
        variables: {
            catalogueId
        },
        skip: !catalogueId,
        ssr: false,
        fetchPolicy: "cache-first"
    });
    const { filters: collaborationsFilters } = util_useCollaborationsFilters(catalogueName);
    const { filters: theShopCatalogueFilters, isFetching: isFetchingTheShopCatalogueFilters } = util_useTheShopCatalogueFilters(catalogueName);
    const source = data?.catalogue?.data?.availableFilters;
    const availableFilters = (0,react.useMemo)(()=>{
        if (!source?.length) {
            return null;
        }
        return [
            ...collaborationsFilters,
            ...theShopCatalogueFilters,
            ...source
        ].reduce((result, filterData)=>{
            result[filterData.filterType] = filterData;
            return result;
        }, {});
    }, [
        collaborationsFilters,
        source,
        theShopCatalogueFilters
    ]);
    return {
        availableFilters,
        isFetching: isFetchingFilters || isFetchingTheShopCatalogueFilters
    };
};
/* harmony default export */ const util_useAvailableFilters = (useAvailableFilters);

;// CONCATENATED MODULE: ./src/pages/catalog/util/useCatalogueFilters.ts






const filterActualByAvailable = (actual, available, typeSelection)=>{
    if (!actual || !available?.length) {
        return null;
    }
    let result;
    if (typeSelection === "MULTIPLE") {
        result = actual.split(",").filter((item)=>item && available.find((param)=>{
                let { id } = param;
                return item === id;
            }));
    } else {
        result = available.find((param)=>{
            let { id } = param;
            return actual === id;
        }) ? [
            actual
        ] : null;
    }
    return result?.length ? result : null;
};
const BOOLEAN_FILTERS_SEARCH_PARAMS_KEY_MAP = {
    gwp: "giftWithPurchase",
    sale: "hasDiscount"
};
const useCatalogueFilters = (catalogueId, catalogueName)=>{
    const [searchParams] = (0,contexts/* useSearchParams */.lr)();
    const { availableFilters, isFetching } = util_useAvailableFilters(catalogueId, catalogueName);
    const isEcommerceTwoZeroEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.ecommerceTwoZero);
    const { appliedFilters, appliedFiltersForRequest, appliedFiltersCount, appliedBooleanFilters, appliedBooleanFiltersCount, appliedBooleanFiltersRequest, collaboration, filterCatalogueId } = (0,react.useMemo)(()=>{
        let result = {
            appliedFilters: null,
            appliedFiltersForRequest: null,
            appliedFiltersCount: 0,
            appliedBooleanFilters: null,
            appliedBooleanFiltersCount: 0,
            appliedBooleanFiltersRequest: null,
            collaboration: null,
            filterCatalogueId: null
        };
        // TODO: Move all standalone filters to same availability system as other filters — added on 11–12–2023 by algeas
        if (isEcommerceTwoZeroEnabled) {
            result.appliedBooleanFilters = Object.keys(BOOLEAN_FILTERS_SEARCH_PARAMS_KEY_MAP).reduce((acc, filterSearchParamKey)=>{
                if (searchParams[filterSearchParamKey] === "true") {
                    const filterKey = BOOLEAN_FILTERS_SEARCH_PARAMS_KEY_MAP[filterSearchParamKey];
                    acc.push(filterSearchParamKey);
                    result.appliedBooleanFiltersCount += 1;
                    result.appliedBooleanFiltersRequest = result.appliedBooleanFiltersRequest || {};
                    result.appliedBooleanFiltersRequest[filterKey] = true;
                }
                return acc;
            }, []);
        }
        if (!availableFilters) {
            return result;
        }
        result.appliedFilters = Object.values(availableFilters).reduce((acc, param)=>{
            let { id, filterType, filterSelectionType, values } = param;
            const searchParamsValue = searchParams[filterType.toLowerCase()] || searchParams[id];
            const filterValue = filterActualByAvailable(searchParamsValue, values, filterSelectionType);
            if (filterValue?.length) {
                result.appliedFiltersCount += filterValue?.length;
                acc[filterType] = filterValue;
                if (filterType === "COLLABORATION") {
                    result.collaboration = filterValue[0];
                    return acc;
                }
                if (filterType === "CATALOGUE") {
                    result.filterCatalogueId = parseInt(filterValue[0]);
                    return acc;
                }
                result.appliedFiltersForRequest = result.appliedFiltersForRequest || [];
                result.appliedFiltersForRequest.push({
                    type: filterType,
                    filterValueIdList: filterValue
                });
            }
            return acc;
        }, {});
        // ATTN we drop category if there are brands or notes
        //   because brands & notes is a "search by your knowledge"
        //   when category - is an our recommendations as a service PF-749
        if ((result.appliedFilters.BRANDS || result.appliedFilters.NOTES || result.appliedFilters.TAGS) && (result.appliedFilters.CATEGORY || result.appliedFilters.COLLABORATION)) {
            result.appliedFiltersCount--;
            result.appliedFiltersForRequest.filter((param)=>{
                let { type } = param;
                return type !== "CATEGORY";
            });
            result.collaboration = null;
            delete result.appliedFilters.CATEGORY;
            delete result.appliedFilters.COLLABORATION;
        }
        return result;
    }, [
        availableFilters,
        isEcommerceTwoZeroEnabled,
        searchParams
    ]);
    return {
        appliedFilters,
        appliedFiltersForRequest,
        appliedFiltersCount,
        appliedBooleanFilters,
        appliedBooleanFiltersCount,
        appliedBooleanFiltersRequest,
        availableFilters,
        collaboration,
        filterCatalogueId,
        isFetching
    };
};
/* harmony default export */ const util_useCatalogueFilters = (useCatalogueFilters);

;// CONCATENATED MODULE: ./src/pages/catalog/util/useCatalogueSorting.ts



const useCatalogueSorting = ()=>{
    const [searchParams] = (0,contexts/* useSearchParams */.lr)();
    const isEcommerceTwoZeroEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.ecommerceTwoZero);
    const hasSelectedSort = Boolean(searchParams?.sort);
    return isEcommerceTwoZeroEnabled && hasSelectedSort ? searchParams?.sort : null;
};
/* harmony default export */ const util_useCatalogueSorting = (useCatalogueSorting);

;// CONCATENATED MODULE: ./src/pages/catalog/util/useCatalogueContextValue.ts








const useCatalogueContextValue = (props)=>{
    const { catalogueId, catalogueName, defaultFilters, isEcommerce, isExtras, productsFeed, defaultSort, limit = 24, filtersStrategy = "replace" } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { appliedFilters, appliedFiltersForRequest, appliedFiltersCount, appliedBooleanFilters, appliedBooleanFiltersCount, appliedBooleanFiltersRequest, availableFilters, collaboration, filterCatalogueId, isFetching: isFetchingFilters } = util_useCatalogueFilters(catalogueId, catalogueName);
    const appliedSortingForRequest = util_useCatalogueSorting();
    const { isBot } = (0,useDevice/* default */.Z)();
    const isNoPaginationEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.noPaginationForBots) && isBot;
    const variables = (0,react.useMemo)(()=>{
        const filter = filtersStrategy === "merge" ? [
            ...defaultFilters || [],
            ...appliedFiltersForRequest || []
        ] : appliedFiltersForRequest || defaultFilters;
        return {
            id: filterCatalogueId || catalogueId,
            input: {
                limit: isNoPaginationEnabled ? null : limit,
                filter,
                offset: 0,
                sort: defaultSort || appliedSortingForRequest,
                productsFeed,
                // Standalone boolean filters
                ...appliedBooleanFiltersRequest
            },
            withCount: true,
            availableForQueue: !isEcommerce && !isExtras,
            ecommTradingItem: isExtras ? "Extras" : "Ecommerce"
        };
    }, [
        appliedFiltersForRequest,
        appliedSortingForRequest,
        filtersStrategy,
        appliedBooleanFiltersRequest,
        catalogueId,
        isEcommerce,
        isExtras,
        defaultFilters,
        defaultSort,
        productsFeed,
        filterCatalogueId,
        limit,
        isNoPaginationEnabled
    ]);
    const { data: catalogueProducts, isFetching: isFetchingProducts, fetchMore } = (0,useCatalogueProducts/* default */.Z)({
        variables,
        skip: Boolean(collaboration) || isFetchingFilters || appliedFilters?.BRANDS?.length > 8,
        notifyOnNetworkStatusChange: true,
        ssr: false
    });
    const { data: collaborationProducts, isFetching: isFetchingCollaborationProducts } = (0,useCollaborationProducts/* default */.Z)({
        catalogueType: catalogueName === "perfumes" ? "perfumes" : "colognes",
        collaboration: "saks",
        productsFeed: "SAKS_SELECTED",
        skip: !collaboration
    });
    const productsLengthRef = (0,react.useRef)();
    productsLengthRef.current = catalogueProducts?.products?.length ?? collaborationProducts?.length;
    const handleFetchMore = (0,react.useCallback)(()=>{
        fetchMore({
            variables: {
                ...variables,
                input: {
                    ...variables.input,
                    offset: productsLengthRef.current
                }
            }
        });
    }, [
        fetchMore,
        variables
    ]);
    const scrollToFilters = (0,react.useCallback)(()=>{
        if (isMobile) {
            setTimeout(()=>{
                // scroll to the top of the list
                (0,scrollToElement/* default */.Z)("#catalogueFilters", {
                    onlyUp: true,
                    compensation: (0,devicePx/* default */.Z)(-20),
                    smooth: true
                });
            }, 50);
        }
    }, [
        isMobile
    ]);
    return {
        catalogueName: catalogueName,
        products: catalogueProducts?.products ?? collaborationProducts,
        count: catalogueProducts?.count ?? collaborationProducts?.length,
        availableFilters,
        appliedFilters,
        appliedFiltersCount,
        appliedBooleanFilters,
        appliedBooleanFiltersCount,
        isFetchingFilters,
        isFetchingProducts: isFetchingProducts || isFetchingCollaborationProducts,
        isEcommerce,
        isExtras,
        fetchMore: handleFetchMore,
        scrollToFilters
    };
};
/* harmony default export */ const util_useCatalogueContextValue = (useCatalogueContextValue);

// EXTERNAL MODULE: ./src/pages/catalog/util/context.ts
var context = __webpack_require__(63985);
;// CONCATENATED MODULE: ./src/pages/catalog/components/CatalogContextProvider/CatalogContextProvider.tsx








const CatalogueContextProviderContent = (props)=>{
    const { children } = props;
    const contextValue = util_useCatalogueContextValue(props);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* CatalogueContext */.N.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhitePageLayout/* default */.Z, {
            children: children
        })
    });
};
const CatalogueContextProvider = (props)=>{
    const { children, catalogueName, defaultFilters, defaultSort, isEcommerce = false, isExtras = false, productsFeed, limit, filtersStrategy } = props;
    const { catalogueId, isFetching } = (0,useCatalogueId/* default */.Z)({
        catalogueName
    });
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSkeleton/* default */.Z, {});
    }
    if (!catalogueId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Redirect/* default */.Z, {
            to: links/* default */.ZP.subscription.main
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogueContextProviderContent, {
        catalogueId: catalogueId,
        catalogueName: catalogueName,
        filtersStrategy: filtersStrategy,
        defaultFilters: defaultFilters,
        defaultSort: defaultSort,
        isEcommerce: isEcommerce,
        isExtras: isExtras,
        productsFeed: productsFeed,
        limit: limit,
        children: children
    });
};
/* harmony default export */ const CatalogContextProvider = (CatalogueContextProvider);


/***/ }),

/***/ 68575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ FiltersSection_FiltersSection)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/pages/catalog/util/context.ts
var context = __webpack_require__(63985);
// EXTERNAL MODULE: ./local_modules/modals/standaloneModal.tsx
var standaloneModal = __webpack_require__(8813);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(87586);
// EXTERNAL MODULE: ./src/pages/catalog/util/useFragranceTagGroups.ts + 16 modules
var useFragranceTagGroups = __webpack_require__(57434);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
;// CONCATENATED MODULE: ./src/pages/catalog/components/FilterModalsActionButtons/messages.ts
/* harmony default export */ const messages = ({
    primaryButton: {
        en: `
      Show <span class="text-gold-30" data-testid="count">{count}</span>
      {productType, select, perfume {perfume} cologne {cologne} other {product}}
      {count, plural, one {result} other {results}}
    `
    },
    clearAll: {
        en: "Clear all"
    },
    emptyNote: {
        en: "We couldn't find anything in our catalog that matches your selections. Please try editing your search."
    },
    tooMuchBrands: {
        en: "Please edit your search down to eight brands or less, and try\xa0again."
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/FilterModalsActionButtons/FilterModalsActionButtons.tsx











const FilterModalsActionButtons = (param)=>{
    let { filterKey, onApply } = param;
    const type = filterKey.toLowerCase();
    const { isMobile } = (0,useDevice/* default */.Z)();
    const pathname = (0,contexts/* usePathname */.jD)();
    const [, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { availableFilters, appliedFilters, count, isFetchingProducts, appliedFiltersCount } = (0,context/* useCatalogueContext */.J)();
    const targetParams = appliedFilters?.[filterKey];
    const prevParamsRef = (0,react.useRef)(targetParams);
    const handleClearAll = ()=>{
        (0,analytics/* track */.j)("Filter clear all", {
            filterBy: filterKey
        });
        setSearchParams((prevParams)=>({
                ...prevParams,
                [type]: undefined
            }), false, false);
    };
    const handleApply = ()=>{
        if (!isFetchingProducts && appliedFiltersCount > 0 && count === 0) {
            (0,analytics/* track */.j)("Filter zero result display", {
                flow: "Applied by user"
            });
        }
        (0,analytics/* track */.j)("Filter apply", {
            notes: appliedFilters?.NOTES,
            productBrands: appliedFilters?.BRANDS,
            tagNames: appliedFilters?.TAGS?.map((id)=>{
                const item = availableFilters.TAGS?.values.find((item)=>id === item.id);
                return item?.name || id;
            })
        });
        onApply();
    };
    const isPrimaryButtonVisible = (0,react.useRef)(false);
    const isClearAllButtonVisible = Boolean(targetParams?.length);
    if (!isPrimaryButtonVisible.current && targetParams !== prevParamsRef.current) {
        isPrimaryButtonVisible.current = true;
    }
    if (!isPrimaryButtonVisible.current && !isClearAllButtonVisible) {
        return null;
    }
    let noteMessage;
    if (filterKey === "BRANDS" && targetParams?.length > 8) {
        noteMessage = messages.tooMuchBrands;
    } else if (!isFetchingProducts && count === 0) {
        noteMessage = messages.emptyNote;
    }
    const productType = pathname === links/* default */.ZP.subscription.perfumes ? "perfume" : pathname === links/* default */.ZP.subscription.colognes ? "cologne" : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("sticky bottom-0 bg-white pb-16 pt-8", isMobile ? "px-16 -mx-16" : "px-40 -mx-40"),
        children: [
            Boolean(noteMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-8 text-center",
                message: noteMessage,
                style: "p4",
                color: "gold-70"
            }),
            isPrimaryButtonVisible.current && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: {
                    ...messages.primaryButton,
                    values: {
                        productType,
                        count: count || 0
                    }
                },
                size: 56,
                style: "primary",
                loading: isFetchingProducts,
                fullWidth: true,
                html: true,
                onClick: handleApply,
                "data-testid": "applyButton"
            }),
            isClearAllButtonVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: isPrimaryButtonVisible.current ? "mt-8" : null,
                title: messages.clearAll,
                size: 56,
                style: "tertiary",
                fullWidth: true,
                onClick: handleClearAll,
                "data-testid": "clearButton"
            })
        ]
    });
};
/* harmony default export */ const FilterModalsActionButtons_FilterModalsActionButtons = (FilterModalsActionButtons);

// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(52493);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(39682);
;// CONCATENATED MODULE: ./src/pages/catalog/components/PersonalityTagsModal/components/TagItem/TagItem.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const TagItem_module = ({"active":"ye5yFE","image":"K30YLC"});
;// CONCATENATED MODULE: ./src/pages/catalog/components/PersonalityTagsModal/components/TagItem/TagItem.tsx







const TagItem = (param)=>{
    let { data, appliedGroupTagId, position, onClick } = param;
    const { id, name, rebrandImage, image } = data;
    const isActive = id === appliedGroupTagId;
    const isFaded = Boolean(!isActive && appliedGroupTagId);
    const handleClick = (0,react.useCallback)(()=>{
        onClick(data, position);
    }, [
        data,
        position,
        onClick
    ]);
    const buttonClassName = (0,clsx/* default */.Z)({
        [TagItem_module.active]: isActive,
        "opacity-50": isFaded
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        className: buttonClassName,
        role: "checkbox",
        "aria-checked": isActive,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                className: "w-full",
                aspect: 1,
                fit: "cover",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    className: (0,clsx/* default */.Z)(TagItem_module.image, "rounded"),
                    src: rebrandImage || image,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 text-p4",
                children: name
            })
        ]
    });
};
/* harmony default export */ const TagItem_TagItem = (TagItem);

;// CONCATENATED MODULE: ./src/pages/catalog/components/PersonalityTagsModal/components/TagGroup/messages.ts
/* harmony default export */ const TagGroup_messages = ({
    groupLabel: {
        en: 'Select one option from the "{name}" group'
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/PersonalityTagsModal/components/TagGroup/TagGroup.tsx








const TagGroup = (props)=>{
    const { name, items, shouldScroll, keepSortAndFilters } = props;
    const intl = (0,useIntl/* default */.Z)();
    const groupLabel = intl.formatMessage(TagGroup_messages.groupLabel, {
        name
    });
    const titleRef = (0,react.useRef)(null);
    const { appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const appliedTags = appliedFilters?.TAGS;
    const itemGroupIds = items.map((param)=>{
        let { id } = param;
        return id;
    });
    const appliedGroupTagId = appliedTags?.find((value)=>itemGroupIds.includes(value));
    const [searchParams, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const handleChange = (0,react.useCallback)((tag, position)=>{
        const { id } = tag;
        let tags = appliedTags || [];
        if (appliedGroupTagId) {
            tags = tags.filter((value)=>value !== appliedGroupTagId);
        }
        if (id !== appliedGroupTagId) {
            tags = tags.concat(id);
        }
        // Keep sort and filters params
        const savedSearchParams = keepSortAndFilters ? searchParams : undefined;
        setSearchParams({
            ...savedSearchParams,
            tags: tags.length ? tags : undefined
        }, false, false);
        (0,analytics/* track */.j)("Personalization tag select", {
            position,
            tagCategory: name,
            tagName: tag.name
        });
    }, [
        name,
        appliedGroupTagId,
        appliedTags,
        setSearchParams,
        keepSortAndFilters,
        searchParams
    ]);
    (0,react.useEffect)(()=>{
        let timer;
        if (shouldScroll) {
            // TODO doesn't work without timeout because of
            //  next useEffect in Modal that ruins scroll (even inside element) by body-scroll-frozen - added on 10.01.2022 by sonatskiy
            timer = setTimeout(()=>{
                if (titleRef.current) {
                    titleRef.current.scrollIntoView({
                        behavior: "smooth"
                    });
                }
            }, 500);
        }
        return ()=>{
            clearTimeout(timer);
        };
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: titleRef,
                className: "mb-24 pt-32 text-h8 text-gold-50",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-3 gap-16",
                role: "group",
                "data-testid": `${name.replace(" ", "").toLowerCase()}Group`,
                "aria-label": groupLabel,
                children: items.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TagItem_TagItem, {
                        data: data,
                        position: index + 1,
                        appliedGroupTagId: appliedGroupTagId,
                        onClick: handleChange
                    }, data.id))
            })
        ]
    });
};
/* harmony default export */ const TagGroup_TagGroup = (/*#__PURE__*/react.memo(TagGroup));

;// CONCATENATED MODULE: ./src/pages/catalog/components/PersonalityTagsModal/messages.ts
/* harmony default export */ const PersonalityTagsModal_messages = ({
    title: {
        en: "Personalize"
    },
    description: {
        en: "Explore fragrances for all your moods by filtering to your exact needs."
    },
    descriptionFilter: {
        en: "If you select any of the areas below, your <b>filters</b> will be removed."
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/PersonalityTagsModal/PersonalityTagsModal.tsx









const PersonalityTagsModal = (param)=>{
    let { closeModal, sectionToScroll, keepSortAndFilters } = param;
    const { availableFilters, appliedFilters, appliedFiltersCount, scrollToFilters } = (0,context/* useCatalogueContext */.J)();
    const availableTags = availableFilters?.TAGS;
    const areOtherFiltersApplied = Boolean(!appliedFilters?.TAGS && appliedFiltersCount > 0);
    const groups = (0,useFragranceTagGroups/* default */.Z)({
        availableTags
    });
    const handleApply = (0,react.useCallback)(()=>{
        closeModal();
        scrollToFilters();
    }, [
        closeModal,
        scrollToFilters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlainModal/* default */.ZP, {
        type: "sidebar-right",
        bgColor: "white",
        closeModal: closeModal,
        "data-testid": "personalizeModal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-24",
                message: PersonalityTagsModal_messages.title,
                style: "sh5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: areOtherFiltersApplied ? PersonalityTagsModal_messages.descriptionFilter : PersonalityTagsModal_messages.description,
                style: "p2",
                html: true
            }),
            groups.map((param)=>{
                let { name, items } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagGroup_TagGroup, {
                    name: name,
                    items: items,
                    shouldScroll: name === sectionToScroll,
                    keepSortAndFilters: keepSortAndFilters
                }, name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterModalsActionButtons_FilterModalsActionButtons, {
                filterKey: "TAGS",
                onApply: handleApply
            })
        ]
    });
};
/* harmony default export */ const PersonalityTagsModal_PersonalityTagsModal = ((0,standaloneModal/* default */.Z)("personalityTagsModal", PersonalityTagsModal));

// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FilterButton/FilterButton.tsx





const FilterButton = (props)=>{
    const { className, title, iconName, "data-testid": dataTestId, onClick } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, "border-solid-gray-50 h-48 text-gray-70", "desktop-hover:border-gray-80 desktop-hover:text-black", "flex cursor-pointer items-center justify-between rounded bg-gray-10 pl-16 pr-8");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        className: rootClassName,
        "data-testid": dataTestId,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: "t2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-8 text-gray-50",
                name: iconName
            })
        ]
    });
};
/* harmony default export */ const FilterButton_FilterButton = (FilterButton);

// EXTERNAL MODULE: ./src/components/feedback/ModalWithLayers/ModalWithLayers.tsx + 4 modules
var ModalWithLayers = __webpack_require__(99687);
// EXTERNAL MODULE: ./src/components/navigation/ActionListItem/ActionListItem.tsx + 1 modules
var ActionListItem = __webpack_require__(53591);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/CategoryList/CategoryList.tsx






const CategoryList = (param)=>{
    let { filterType, withBorderBottom, onClick } = param;
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { availableFilters } = (0,context/* useCatalogueContext */.J)();
    const availableCategories = availableFilters?.[filterType]?.values;
    if (!availableCategories?.length) {
        return null;
    }
    const urlKey = filterType.toLowerCase();
    const handleClick = (value)=>{
        (0,analytics/* track */.j)("Product filter click", {
            filterBy: value
        });
        setSearchParams({
            [urlKey]: value
        }, false, false);
        onClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: availableCategories.map((param, index)=>{
            let { id, name, label } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionListItem/* default */.Z, {
                title: name,
                label: label,
                style: "black",
                withBorder: index > 0,
                withBorderBottom: withBorderBottom && index === availableCategories.length - 1,
                "data-testid": id,
                onClick: ()=>handleClick(id)
            }, id);
        })
    });
};
/* harmony default export */ const CategoryList_CategoryList = (/*#__PURE__*/react.memo(CategoryList));

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./src/helpers/primitives/string.ts
var string = __webpack_require__(6320);
// EXTERNAL MODULE: ./src/components/dataDisplay/BrandCard/BrandCard.tsx + 1 modules
var BrandCard = __webpack_require__(87308);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(6528);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/RowListItemView/RowListItemView.tsx






const RowListItemView = (props)=>{
    const { title, isActive, onClick, ...rest } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const rootClassName = (0,clsx/* default */.Z)("flex h-48 w-full cursor-pointer items-center justify-between desktop-hover:text-gold-50", isActive ? "bg-light-beige" : null, isMobile ? "px-16" : "px-40");
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: rootClassName,
        type: "button",
        ...htmlAttrs,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: "p2"
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "24/checkmark",
                color: "gold-50"
            })
        ]
    });
};
/* harmony default export */ const RowListItemView_RowListItemView = (RowListItemView);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/BrandListItem/messages.ts
/* harmony default export */ const BrandListItem_messages = ({
    limit: {
        en: "Please edit your search down to eight brands or less, and try again."
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/BrandListItem/BrandListItem.tsx









const BrandListItem = (param)=>{
    let { data, type } = param;
    const { id, name, image: logo } = data;
    const intl = (0,useIntl/* default */.Z)();
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const searchParamsBrands = appliedFilters.BRANDS;
    const isActive = searchParamsBrands?.includes(id);
    const isLimitReached = searchParamsBrands?.length > 8;
    const handleClick = (0,react.useCallback)(()=>{
        const brands = isActive ? searchParamsBrands?.filter((value)=>value !== id) : (searchParamsBrands || []).concat(id);
        (0,analytics/* track */.j)(isActive ? "Filter by brands unselect" : "Filter by brands name select", {
            productBrand: name
        });
        setSearchParams((prevParams)=>({
                ...prevParams,
                brands,
                category: undefined,
                beauty: undefined,
                tags: undefined
            }), false, false);
    }, [
        isActive,
        searchParamsBrands,
        id,
        name,
        setSearchParams
    ]);
    const htmlAttrs = {
        role: "checkbox",
        "aria-checked": isActive
    };
    if (isLimitReached && !isActive) {
        htmlAttrs["aria-disabled"] = true;
        htmlAttrs["aria-details"] = intl.formatMessage(BrandListItem_messages.limit);
    }
    if (type === "card") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandCard/* default */.Z, {
            className: "mx-4 w-[176rem] flex-none",
            brand: {
                name,
                logo
            },
            isActive: isActive,
            ...htmlAttrs,
            onClick: handleClick
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowListItemView_RowListItemView, {
        title: data.name,
        isActive: isActive,
        ...htmlAttrs,
        onClick: handleClick
    });
};
/* harmony default export */ const BrandListItem_BrandListItem = (/*#__PURE__*/react.memo(BrandListItem));

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/BrandsLayer/messages.ts
/* harmony default export */ const BrandsLayer_messages = ({
    title: {
        en: "Filter by brands"
    },
    popularBrands: {
        en: "Popular brands"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/BrandsLayer/BrandsLayer.tsx











const BrandsLayer = (param)=>{
    let { onApply } = param;
    const { availableFilters } = (0,context/* useCatalogueContext */.J)();
    const availableFilter = availableFilters.BRANDS;
    const availableBrands = availableFilter?.values;
    const { groupByFirstLetter = true } = availableFilter?.settings || {};
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { sortedBrands, brandGroups, popularBrands } = (0,react.useMemo)(()=>{
        if (!availableBrands) {
            return {};
        }
        const popularBrands = availableBrands.filter((param)=>{
            let { popular } = param;
            return popular;
        });
        const sortedBrands = [
            ...availableBrands
        ].sort((a, b)=>a.name.localeCompare(b.name));
        // if grouping is enabled group by a first letter, otherwise create one single group
        let brandGroups = groupByFirstLetter ? sortedBrands.reduce((result, item)=>{
            let firstLetter = string/* default */.Z.getFirstLetter(item.name);
            if (/\d/.test(firstLetter)) {
                firstLetter = "0-9";
            }
            result[firstLetter] = result[firstLetter] || [];
            result[firstLetter].push(item);
            return result;
        }, {}) : null;
        return {
            sortedBrands,
            brandGroups,
            popularBrands
        };
    }, [
        availableBrands,
        groupByFirstLetter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-8 flex-none",
                message: BrandsLayer_messages.title,
                style: "sh3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    Boolean(popularBrands.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "mb-8 pb-8 pt-24",
                                message: BrandsLayer_messages.popularBrands,
                                style: "h8",
                                color: "gold-50"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx/* default */.Z)("no-scrollbar my-0 flex overflow-x-auto", isMobile ? "-mx-16 px-12" : "-mx-40 px-36"),
                                role: "group",
                                children: popularBrands.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BrandListItem_BrandListItem, {
                                        data: data,
                                        type: "card"
                                    }, data.name))
                            })
                        ]
                    }),
                    Boolean(brandGroups) && Object.keys(brandGroups).map((letter)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    className: "pb-8 pt-24",
                                    message: String(letter),
                                    style: "h8",
                                    color: "gold-50"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx/* default */.Z)(isMobile ? "-mx-16" : "-mx-40"),
                                    role: "group",
                                    children: brandGroups[letter].map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BrandListItem_BrandListItem, {
                                            data: data,
                                            type: "row"
                                        }, data.id))
                                })
                            ]
                        }, letter)),
                    Boolean(!groupByFirstLetter && sortedBrands) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)("mt-24", isMobile ? "-mx-16" : "-mx-40"),
                        role: "group",
                        children: sortedBrands.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BrandListItem_BrandListItem, {
                                data: data,
                                type: "row"
                            }, data.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterModalsActionButtons_FilterModalsActionButtons, {
                filterKey: "BRANDS",
                onApply: onApply
            })
        ]
    });
};
/* harmony default export */ const BrandsLayer_BrandsLayer = (BrandsLayer);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/FilterLayerOpenButton/messages.ts
/* harmony default export */ const FilterLayerOpenButton_messages = ({
    BRANDS: {
        en: "Filter by brands"
    },
    NOTES: {
        en: "Filter by perfume notes"
    },
    clear: {
        en: "Clear"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/FilterLayerOpenButton/FilterLayerOpenButton.tsx










const FilterLayerOpenButton = (param)=>{
    let { layerId, withBorder } = param;
    const title = FilterLayerOpenButton_messages[layerId];
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { appliedFilters, availableFilters } = (0,context/* useCatalogueContext */.J)();
    const appliedFilterIds = appliedFilters?.[layerId];
    const availableItems = availableFilters?.[layerId]?.values;
    const appliedFilterNames = (0,react.useMemo)(()=>{
        if (!appliedFilterIds?.length || !availableItems?.length) {
            return null;
        }
        return appliedFilterIds.map((id)=>{
            const item = availableItems.find((item)=>item.id === id);
            return item?.name;
        }).filter(Boolean).join(",");
    }, [
        appliedFilterIds,
        availableItems
    ]);
    const type = layerId.toLowerCase();
    const handleClearClick = (0,react.useCallback)((event)=>{
        event.stopPropagation();
        (0,analytics/* track */.j)("Filter clear result click", {
            filterBy: layerId === "BRANDS" ? "All brands" : "All notes"
        });
        setSearchParams((prevParams)=>({
                ...prevParams,
                [type]: undefined
            }), false, false);
    }, [
        layerId,
        setSearchParams,
        type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithLayers/* default */.Z.OpenButton, {
        layerId: layerId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionListItem/* default */.Z, {
            title: title,
            style: "black",
            withArrow: false,
            withBorder: withBorder,
            "data-testid": `${type}OpenButton`,
            children: Boolean(appliedFilterNames) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 flex items-baseline justify-start text-left",
                "data-testid": `${type}ActiveList`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: appliedFilterNames,
                        style: "p5",
                        color: "gray-80"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                        className: "ml-8 inline-flex cursor-pointer desktop-hover:text-gold-70",
                        tag: "div",
                        role: "button",
                        tabIndex: 0,
                        "data-testid": `${type}ClearAll`,
                        onClick: handleClearClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: FilterLayerOpenButton_messages.clear,
                                style: "p5",
                                tag: "b"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                className: "self-center",
                                name: "16/close"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ const FilterLayerOpenButton_FilterLayerOpenButton = (FilterLayerOpenButton);

// EXTERNAL MODULE: ./src/components/layout/Grid/Grid.tsx + 1 modules
var Grid = __webpack_require__(53285);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/NoteListItem/NoteListItem.tsx









const NoteListItem = (param)=>{
    let { data, type } = param;
    const { id, name, rebrandImage, image } = data;
    const [, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const searchParamsNotes = appliedFilters.NOTES;
    const isActive = searchParamsNotes?.includes(id);
    const handleClick = (0,react.useCallback)(()=>{
        const notes = isActive ? searchParamsNotes?.filter((value)=>value !== id) : (searchParamsNotes || []).concat(id);
        (0,analytics/* track */.j)(isActive ? "Filter by notes unselect" : "Filter by notes name select", {
            note: name
        });
        setSearchParams((prevParams)=>({
                ...prevParams,
                notes,
                category: undefined,
                beauty: undefined,
                tags: undefined
            }), false, false);
    }, [
        id,
        isActive,
        name,
        searchParamsNotes,
        setSearchParams
    ]);
    const htmlAttrs = {
        role: "checkbox",
        "aria-checked": isActive
    };
    if (type === "card") {
        const cardClassName = (0,clsx/* default */.Z)("border-solid-transparent h-full w-full cursor-pointer rounded", "desktop-hover:border-gold-50 desktop-hover:opacity-100", {
            ["border-gold-50 shadow-[0_0_0_2px_transparent] shadow-gold-50"]: isActive,
            ["opacity-50"]: searchParamsNotes?.length && !isActive
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            className: cardClassName,
            type: "button",
            ...htmlAttrs,
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                    className: "w-full overflow-hidden rounded",
                    src: rebrandImage || image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "px-4 py-8",
                    message: name,
                    style: "p3"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowListItemView_RowListItemView, {
        title: data.name,
        isActive: isActive,
        ...htmlAttrs,
        onClick: handleClick
    });
};
/* harmony default export */ const NoteListItem_NoteListItem = (/*#__PURE__*/react.memo(NoteListItem));

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/NotesLayer/messages.ts
/* harmony default export */ const NotesLayer_messages = ({
    title: {
        en: "Filter by perfume notes"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/components/NotesLayer/NotesLayer.tsx











// TODO react.window?
//  there a lot of notes and they are duplicated by design (image card for every note + alphabet list) - added on 06.01.2022 by sonatskiy
const NotesLayer = (param)=>{
    let { onApply } = param;
    const { availableFilters } = (0,context/* useCatalogueContext */.J)();
    const availableNotes = availableFilters.NOTES.values;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const noteGroups = (0,react.useMemo)(()=>{
        if (!availableNotes) {
            return {};
        }
        // notes are sorted by name from backend
        return availableNotes.reduce((result, item)=>{
            let firstLetter = item.name.charAt(0).toUpperCase();
            result[firstLetter] = result[firstLetter] || [];
            result[firstLetter].push(item);
            return result;
        }, {});
    }, [
        availableNotes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-32 flex-none",
                message: NotesLayer_messages.title,
                style: "sh3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1",
                children: Boolean(availableNotes.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            columns: 3,
                            gutter: 12,
                            role: "group",
                            children: availableNotes.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP.Cell, {
                                    className: "pb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteListItem_NoteListItem, {
                                        data: data,
                                        type: "card"
                                    }, data.name)
                                }))
                        }),
                        Object.keys(noteGroups).map((letter)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        className: "mt-24 pb-8 pt-24",
                                        message: letter,
                                        style: "h8",
                                        color: "gold-50"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx/* default */.Z)("my-0", isMobile ? "-mx-16" : "-mx-40"),
                                        role: "group",
                                        children: noteGroups[letter].map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(NoteListItem_NoteListItem, {
                                                data: data,
                                                type: "row"
                                            }, data.id))
                                    })
                                ]
                            }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterModalsActionButtons_FilterModalsActionButtons, {
                filterKey: "NOTES",
                onApply: onApply
            })
        ]
    });
};
/* harmony default export */ const NotesLayer_NotesLayer = (NotesLayer);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/messages.ts
/* harmony default export */ const FiltersModal_messages = ({
    title: {
        en: "Filters"
    },
    description: {
        en: "If you select any of the filters below, your <b>personalized selections</b> will be removed."
    },
    expand: {
        en: "Expand your search"
    },
    notes: {
        en: "Filter by perfume notes"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/FiltersModal/FiltersModal.tsx












const FiltersModal = (param)=>{
    let { closeModal } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { availableFilters, appliedFilters, scrollToFilters } = (0,context/* useCatalogueContext */.J)();
    const handleApply = (0,react.useCallback)(()=>{
        closeModal();
        scrollToFilters();
    }, [
        closeModal,
        scrollToFilters
    ]);
    const areCategoriesAvailable = Boolean(availableFilters?.CATEGORY || availableFilters?.BEAUTY || availableFilters?.CATALOGUE || availableFilters?.COLLABORATION);
    const areRegularCategoriesAvailable = Boolean(availableFilters?.CATEGORY || availableFilters?.BEAUTY);
    const areBrandsAvailableBrands = Boolean(availableFilters?.BRANDS);
    const areNotesAvailable = Boolean(availableFilters?.NOTES);
    const areTagsFilerApplied = Boolean(appliedFilters?.TAGS?.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalWithLayers/* default */.Z, {
        type: isMobile ? "sidebar-left" : "sidebar-right",
        bgColor: "white",
        closeModal: closeModal,
        "data-testid": "filtersModal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: areTagsFilerApplied ? "mb-24" : "mb-32",
                message: FiltersModal_messages.title,
                style: "sh5"
            }),
            areTagsFilerApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-32",
                message: FiltersModal_messages.description,
                style: "p2",
                html: true
            }),
            areCategoriesAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_CategoryList, {
                        filterType: "COLLABORATION",
                        withBorderBottom: areRegularCategoriesAvailable,
                        onClick: handleApply
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_CategoryList, {
                        filterType: "CATALOGUE",
                        onClick: handleApply
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_CategoryList, {
                        filterType: "CATEGORY",
                        onClick: handleApply
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_CategoryList, {
                        filterType: "BEAUTY",
                        onClick: handleApply
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "mb-24 mt-48",
                        message: FiltersModal_messages.expand,
                        style: "sh5"
                    })
                ]
            }),
            areBrandsAvailableBrands && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayerOpenButton_FilterLayerOpenButton, {
                        layerId: "BRANDS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithLayers/* default */.Z.Layer, {
                        id: "BRANDS",
                        bgColor: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsLayer_BrandsLayer, {
                            onApply: handleApply
                        })
                    })
                ]
            }),
            areNotesAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayerOpenButton_FilterLayerOpenButton, {
                        layerId: "NOTES",
                        withBorder: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithLayers/* default */.Z.Layer, {
                        id: "NOTES",
                        bgColor: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesLayer_NotesLayer, {
                            onApply: handleApply
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const FiltersModal_FiltersModal = ((0,standaloneModal/* default */.Z)("filtersModal", FiltersModal));

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/view/Desktop/messages.ts
/* harmony default export */ const Desktop_messages = ({
    more: {
        en: "and {count} more..."
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/view/Desktop/Desktop.tsx






const Desktop = (props)=>{
    const { className, uniqueKey, placement = "page", children } = props;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [hiddenTotal, setHiddenTotal] = (0,react.useState)(0);
    const listRef = (0,react.useRef)(null);
    const buttonRef = (0,react.useRef)(null);
    const marginValueRef = (0,react.useRef)(null);
    const maxWidthCompensation = placement === "page" ? 100 : 120;
    // TODO hope we will remove it - added on 01.10.2021 by sonatskiy
    (0,react.useLayoutEffect)(()=>{
        const rootEl = listRef.current;
        const childList = Array.from(rootEl.children);
        if (isOpen) {
            childList.forEach((child)=>{
                child.classList.remove("hidden");
            });
        } else {
            const maxWidth = rootEl.parentElement.clientWidth - maxWidthCompensation;
            let width = 0;
            let hiddenCount = 0;
            if (marginValueRef.current === null) {
                const elementInTheMiddleStyle = childList[1] ? getComputedStyle(childList[1]) : null;
                marginValueRef.current = elementInTheMiddleStyle ? parseInt(elementInTheMiddleStyle.marginLeft) + parseInt(elementInTheMiddleStyle.marginRight) : 12 // fallback
                ;
            }
            childList.forEach((child)=>{
                width += child.clientWidth + marginValueRef.current;
                if (width >= maxWidth && child !== buttonRef.current) {
                    child.classList.add("hidden");
                    hiddenCount++;
                } else {
                    child.classList.remove("hidden");
                }
            });
            setHiddenTotal(hiddenCount);
        }
        rootEl.classList.remove("opacity-0");
    }, [
        isOpen,
        uniqueKey,
        maxWidthCompensation
    ]);
    return(// key is required for correct calculations and render
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex justify-start opacity-0", isOpen && "flex-wrap"),
        ref: listRef,
        "data-testid": "activeFilterList",
        children: [
            children,
            !isOpen && hiddenTotal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                ref: buttonRef,
                className: "cursor-pointer",
                onClick: ()=>setIsOpen(true),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: {
                        ...Desktop_messages.more,
                        values: {
                            count: hiddenTotal
                        }
                    },
                    style: "p4",
                    color: "gold-70"
                })
            })
        ]
    }, uniqueKey));
};
/* harmony default export */ const Desktop_Desktop = (/*#__PURE__*/react.memo(Desktop));

// EXTERNAL MODULE: ./src/components/layout/WidthContainerCompensator/WidthContainerCompensator.tsx
var WidthContainerCompensator = __webpack_require__(34626);
;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/view/Mobile/Mobile.tsx




const Mobile = (param)=>{
    let { className, children } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainerCompensator/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "no-scrollbar overflow-auto px-16"),
        "data-testid": "activeFilterList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-start",
            children: children
        })
    });
};
/* harmony default export */ const Mobile_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/components/ButtonView/ButtonView.tsx





const ButtonView = (props)=>{
    const { title, isBold, "data-testid": dataTestId, onClick } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        className: "mr-12 flex cursor-pointer whitespace-nowrap select-none desktop-hover:text-gray-80",
        onClick: onClick,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: isMobile ? "p5" : "p4",
                tag: isBold ? "b" : "span"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "flex-none self-center",
                name: "16/close"
            })
        ]
    });
};
/* harmony default export */ const ButtonView_ButtonView = (ButtonView);

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/components/FilterItem/FilterItem.tsx





const filterByOptions = {
    BEAUTY: "Category",
    CATEGORY: "Category",
    NOTES: "Note",
    TAGS: "Tag",
    BRANDS: "Brand"
};
const FilterItem = (props)=>{
    const { value, filterKey, itemsData } = props;
    const type = filterKey.toLowerCase();
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Filter clear result click", {
            filterBy: filterByOptions[filterKey]
        });
        setSearchParams((prevSearchParams)=>{
            const newSearchParams = {
                ...prevSearchParams
            };
            if (filterKey === "CATEGORY") {
                delete newSearchParams[type];
            } else if (filterKey === "FULL_BOTTLE_TYPES") {
                // TODO: It is necessary to unify the source of search params keys (currently types and IDs are used together) — added on 17–10–2023 by algeas
                delete newSearchParams?.fullBottleTypes;
            } else {
                newSearchParams[type] = newSearchParams[type].split(",").filter((id)=>value !== id).join(",");
            }
            return newSearchParams;
        }, false, false);
    };
    const { name } = itemsData.find((param)=>{
        let { id } = param;
        return id === value;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonView_ButtonView, {
        title: name,
        onClick: handleClick,
        "data-testid": `${type}ActiveFilter`
    });
};
/* harmony default export */ const FilterItem_FilterItem = (/*#__PURE__*/react.memo(FilterItem));

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/components/BooleanFilterItem/messages.ts
/* harmony default export */ const BooleanFilterItem_messages = ({
    gwp: {
        en: "Gift with purchase"
    },
    sale: {
        en: "Sale! Up to 50% off"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/components/BooleanFilterItem/BooleanFilterItem.tsx






// TODO: Add new values to analytic event — added on 11–12–2023 by algeas
const BooleanFilterItem_filterByOptions = {
    gwp: "GWP",
    sale: "Sale"
};
const BooleanFilterItem = (props)=>{
    const { filterKey } = props;
    const type = filterKey.toLowerCase();
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Filter clear result click", {
            filterBy: BooleanFilterItem_filterByOptions[filterKey]
        });
        setSearchParams((prevSearchParams)=>{
            const newSearchParams = {
                ...prevSearchParams
            };
            delete newSearchParams[type];
            return newSearchParams;
        }, false, false);
    };
    const title = BooleanFilterItem_messages[filterKey];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonView_ButtonView, {
        title: title,
        onClick: handleClick,
        "data-testid": `${type}ActiveBooleanFilter`
    });
};
/* harmony default export */ const BooleanFilterItem_BooleanFilterItem = (/*#__PURE__*/react.memo(BooleanFilterItem));

// EXTERNAL MODULE: ./src/helpers/actions/scrollToElement.ts
var scrollToElement = __webpack_require__(4570);
// EXTERNAL MODULE: ./src/helpers/devicePx.ts
var devicePx = __webpack_require__(48073);
;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/components/ClearAllButton/messages.ts
/* harmony default export */ const ClearAllButton_messages = ({
    title: {
        en: "Clear results"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/components/ClearAllButton/ClearAllButton.tsx









const ClearAllButton = ()=>{
    const history = (0,contexts/* useHistory */.k6)();
    const pathname = (0,contexts/* usePathname */.jD)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Filter clear result click", {
            filterBy: "All"
        });
        // drop searchParams
        history.push(pathname, {
            scroll: false
        });
        if (isMobile) {
            (0,scrollToElement/* default */.Z)("#catalogueFilters", {
                onlyUp: true,
                compensation: (0,devicePx/* default */.Z)(-20),
                smooth: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonView_ButtonView, {
        title: ClearAllButton_messages.title,
        isBold: true,
        onClick: handleClick,
        "data-testid": "clearAllFilters"
    });
};
/* harmony default export */ const ClearAllButton_ClearAllButton = (ClearAllButton);

;// CONCATENATED MODULE: ./src/pages/catalog/components/ActiveFiltersList/ActiveFiltersList.tsx









const ActiveFiltersList = (param)=>{
    let { className } = param;
    const { appliedFilters, appliedFiltersCount, availableFilters, appliedBooleanFilters, appliedBooleanFiltersCount } = (0,context/* useCatalogueContext */.J)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    if (!appliedFiltersCount && !appliedBooleanFiltersCount) {
        return null;
    }
    const Component = isMobile ? Mobile_Mobile : Desktop_Desktop;
    const isClearAllButtonVisible = appliedFiltersCount > 1;
    // TODO: Refactor after code freeze — added on 11–12–2023 by algeas
    const uniqueKey = Object.values({
        ...appliedFilters,
        ...appliedBooleanFilters
    }).reduce((acc, value)=>{
        return acc + value;
    }, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, {
        className: className,
        uniqueKey: uniqueKey,
        children: [
            isClearAllButtonVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAllButton_ClearAllButton, {}),
            appliedFiltersCount ? Object.keys(appliedFilters).map((key)=>appliedFilters[key].map((value)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItem_FilterItem, {
                        value: value,
                        filterKey: key,
                        itemsData: availableFilters[key].values
                    }, value))) : null,
            appliedBooleanFiltersCount ? appliedBooleanFilters.map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BooleanFilterItem_BooleanFilterItem, {
                    filterKey: key
                }, key)) : null
        ]
    });
};
/* harmony default export */ const ActiveFiltersList_ActiveFiltersList = (/*#__PURE__*/react.memo(ActiveFiltersList));

// EXTERNAL MODULE: ./src/components/layout/ScrollableContainer/ScrollableContainer.tsx
var ScrollableContainer = __webpack_require__(71462);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/RowListItemView/RowListItemView.tsx






const RowListItemView_RowListItemView_RowListItemView = (props)=>{
    const { title, isActive, onClick, ...rest } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const activeClassName = isActive ? (0,clsx/* default */.Z)("before:absolute before:-z-1 before:h-full before:bg-light-beige before:content-['']", isMobile ? "before:-inset-x-16" : "before:-inset-x-20") : null;
    const rootClassName = (0,clsx/* default */.Z)("relative z-0 flex h-48 w-full cursor-pointer items-center justify-between desktop-hover:text-gold-50", isMobile ? "px-16" : "px-20", activeClassName);
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: rootClassName,
        type: "button",
        ...htmlAttrs,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: "p2"
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "24/checkmark",
                color: "gold-50"
            })
        ]
    });
};
/* harmony default export */ const components_RowListItemView_RowListItemView = (RowListItemView_RowListItemView_RowListItemView);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/NoteListItem/NoteListItem.tsx









const NoteListItem_NoteListItem_NoteListItem = (param)=>{
    let { data, type } = param;
    const { id, name, rebrandImage, image } = data;
    const [, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const searchParamsNotes = appliedFilters.NOTES;
    const isActive = searchParamsNotes?.includes(id);
    const handleClick = (0,react.useCallback)(()=>{
        const notes = isActive ? searchParamsNotes?.filter((value)=>value !== id) : (searchParamsNotes || []).concat(id);
        (0,analytics/* track */.j)(isActive ? "Filter by notes unselect" : "Filter by notes name select", {
            note: name
        });
        // TODO: Provide update function from useCatalogueContext — added on 28–09–2023 by algeas
        setSearchParams((prevParams)=>({
                ...prevParams,
                notes
            }), false, false);
    }, [
        id,
        isActive,
        name,
        searchParamsNotes,
        setSearchParams
    ]);
    const htmlAttrs = {
        role: "checkbox",
        "aria-checked": isActive
    };
    if (type === "card") {
        const cardClassName = (0,clsx/* default */.Z)("border-solid-transparent h-full w-[92rem] shrink-0 cursor-pointer rounded", "desktop-hover:border-gold-50 desktop-hover:opacity-100", {
            ["border-gold-50 shadow-[0_0_0_2px_transparent] shadow-gold-50"]: isActive
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            className: cardClassName,
            type: "button",
            ...htmlAttrs,
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                    className: "w-full overflow-hidden rounded",
                    src: rebrandImage || image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "px-4 py-8",
                    message: name,
                    style: "p3"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RowListItemView_RowListItemView, {
        title: data.name,
        isActive: isActive,
        ...htmlAttrs,
        onClick: handleClick
    });
};
/* harmony default export */ const components_NoteListItem_NoteListItem = (/*#__PURE__*/react.memo(NoteListItem_NoteListItem_NoteListItem));

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(92988);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FilterDisclosure/FilterDisclosure.tsx






const FILTER_KEY_MAP = {
    PRICE: "price",
    BRANDS: "brands",
    NOTES: "notes",
    SIZES: "sizes",
    TYPES: "types"
};
const FilterDisclosure = (props)=>{
    const { title, filterKey, children, openOnActive = false, "data-testid": dataTestId } = props;
    const [searchParams] = (0,contexts/* useSearchParams */.lr)();
    const isOpenedByDefault = openOnActive && searchParams?.[FILTER_KEY_MAP[filterKey]] !== undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        as: "div",
        defaultOpen: isOpenedByDefault,
        "data-testid": dataTestId,
        children: (param)=>{
            let { open } = param;
            const iconClassName = (0,clsx/* default */.Z)("transform-gpu transition-transform", open && "rotate-180");
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure */.p.Button, {
                        className: "flex w-full cursor-pointer items-center justify-between py-16 text-black hover:text-gold-30",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: title,
                                style: "t5",
                                color: open ? "gold-50" : "black"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                className: iconClassName,
                                name: "32/arrow-down",
                                color: "black"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p.Panel, {
                        className: "pb-24",
                        children: children
                    })
                ]
            });
        }
    });
};
/* harmony default export */ const FilterDisclosure_FilterDisclosure = (FilterDisclosure);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/NotesFilter/messages.ts
/* harmony default export */ const NotesFilter_messages = ({
    title: {
        en: "Filter by perfume notes {quantity}"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/NotesFilter/NotesFilter.tsx












const NotesFilter = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { availableFilters, appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const [selectedLetter, setSelectedLetter] = react.useState(null);
    const selectedNotes = appliedFilters?.NOTES || [];
    const availableNotes = availableFilters.NOTES.values;
    const { noteGroups, popularNotes, firstGroupLetter } = (0,react.useMemo)(()=>{
        if (!availableNotes) {
            return {};
        }
        const popularNotes = availableNotes.filter((param)=>{
            let { name, popular } = param;
            return popular;
        });
        let firstGroupLetter;
        // notes are sorted by name from backend
        const noteGroups = availableNotes.reduce((result, item)=>{
            let firstLetter = item.name.charAt(0).toUpperCase();
            result[firstLetter] = result[firstLetter] || [];
            result[firstLetter].push(item);
            firstGroupLetter = firstGroupLetter || firstLetter;
            return result;
        }, {});
        return {
            noteGroups,
            popularNotes,
            firstGroupLetter
        };
    }, [
        availableNotes
    ]);
    const handleLetterClick = (0,react.useCallback)((letter)=>{
        setSelectedLetter(letter);
    }, []);
    const title = {
        ...NotesFilter_messages.title,
        values: {
            quantity: selectedNotes.length > 0 ? `(${selectedNotes.length})` : ""
        }
    };
    const activeGroupLetter = selectedLetter || firstGroupLetter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDisclosure_FilterDisclosure, {
        title: title,
        filterKey: "NOTES",
        "data-testid": "notesEcommFilter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                        className: "flex gap-20 p-2",
                        isDesktopEnabled: true,
                        children: Boolean(popularNotes.length) && popularNotes.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_NoteListItem_NoteListItem, {
                                data: data,
                                type: "card"
                            }, data.name))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                        className: "-mx-16 mb-24 flex px-16",
                        isDesktopEnabled: true,
                        children: Boolean(noteGroups) && Object.keys(noteGroups).map((letter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                className: "relative mr-32 cursor-pointer pb-8 pt-24 outline-none before:absolute before:-inset-16 before:content-['']",
                                tag: "div",
                                role: "button",
                                tabIndex: 0,
                                onClick: ()=>handleLetterClick(letter),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    message: String(letter),
                                    style: "h7",
                                    color: activeGroupLetter === letter ? "gold-50" : "black"
                                }, letter)
                            }, letter))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)(!isMobile && "-mx-40 mt-24 px-20"),
                        role: "group",
                        children: noteGroups[activeGroupLetter].map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_NoteListItem_NoteListItem, {
                                data: data,
                                type: "row"
                            }, data.id))
                    })
                ]
            })
        })
    });
};
/* harmony default export */ const NotesFilter_NotesFilter = (NotesFilter);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/BrandListItem/messages.ts
/* harmony default export */ const components_BrandListItem_messages = ({
    limit: {
        en: "Please edit your search down to eight brands or less, and try again."
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/BrandListItem/BrandListItem.tsx









const BrandListItem_BrandListItem_BrandListItem = (param)=>{
    let { data, type } = param;
    const { id, name, image: logo } = data;
    const intl = (0,useIntl/* default */.Z)();
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const searchParamsBrands = appliedFilters.BRANDS;
    const isActive = searchParamsBrands?.includes(id);
    const isLimitReached = searchParamsBrands?.length > 8;
    const handleClick = (0,react.useCallback)(()=>{
        const brands = isActive ? searchParamsBrands?.filter((value)=>value !== id) : (searchParamsBrands || []).concat(id);
        (0,analytics/* track */.j)(isActive ? "Filter by brands unselect" : "Filter by brands name select", {
            productBrand: name
        });
        setSearchParams((prevParams)=>({
                ...prevParams,
                brands,
                category: undefined,
                beauty: undefined,
                tags: undefined
            }), false, false);
    }, [
        isActive,
        searchParamsBrands,
        id,
        name,
        setSearchParams
    ]);
    const htmlAttrs = {
        role: "checkbox",
        "aria-checked": isActive
    };
    if (isLimitReached && !isActive) {
        htmlAttrs["aria-disabled"] = true;
        htmlAttrs["aria-details"] = intl.formatMessage(components_BrandListItem_messages.limit);
    }
    if (type === "card") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandCard/* default */.Z, {
            className: "mx-4 w-[146rem] flex-none",
            brand: {
                name,
                logo
            },
            isActive: isActive,
            ...htmlAttrs,
            onClick: handleClick
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RowListItemView_RowListItemView, {
        title: data.name,
        isActive: isActive,
        ...htmlAttrs,
        onClick: handleClick
    });
};
/* harmony default export */ const components_BrandListItem_BrandListItem = (/*#__PURE__*/react.memo(BrandListItem_BrandListItem_BrandListItem));

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/BrandsFilter/messages.ts
/* harmony default export */ const BrandsFilter_messages = ({
    title: {
        en: "Filter by brands {quantity}"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/BrandsFilter/BrandsFilter.tsx













const BrandsFilter = ()=>{
    const { availableFilters, appliedFilters } = (0,context/* useCatalogueContext */.J)();
    const selectedBrands = appliedFilters?.BRANDS || [];
    const availableFilter = availableFilters.BRANDS;
    const availableBrands = availableFilter?.values;
    const { groupByFirstLetter = true } = availableFilter?.settings || {};
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [selectedLetter, setSelectedLetter] = react.useState(null);
    const { brandGroups, popularBrands, brandGroupsKeys, firstGroupLetter } = (0,react.useMemo)(()=>{
        if (!availableBrands) {
            return {};
        }
        const popularBrands = availableBrands.filter((param)=>{
            let { popular } = param;
            return popular;
        });
        const sortedBrands = [
            ...availableBrands
        ].filter((param)=>{
            let { id } = param;
            return id !== "";
        }).sort((a, b)=>a.name.localeCompare(b.name));
        let firstGroupLetter;
        // if grouping is enabled group by a first letter, otherwise create one single group
        let brandGroups = groupByFirstLetter ? sortedBrands.reduce((result, item)=>{
            let firstLetter = string/* default */.Z.getFirstLetter(item.name);
            if (/\d/.test(firstLetter)) {
                firstLetter = "0-9";
            }
            result[firstLetter] = result[firstLetter] || [];
            result[firstLetter].push(item);
            firstGroupLetter = firstGroupLetter || firstLetter;
            return result;
        }, {}) : null;
        const brandGroupsKeys = Object.keys(brandGroups).sort((a, b)=>a.localeCompare(b));
        return {
            brandGroups,
            brandGroupsKeys,
            popularBrands,
            firstGroupLetter
        };
    }, [
        availableBrands,
        groupByFirstLetter
    ]);
    const handleLetterClick = (0,react.useCallback)((letter)=>{
        setSelectedLetter(letter);
    }, []);
    const title = {
        ...BrandsFilter_messages.title,
        values: {
            quantity: selectedBrands.length > 0 ? `(${selectedBrands.length})` : ""
        }
    };
    const activeGroupLetter = selectedLetter || firstGroupLetter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDisclosure_FilterDisclosure, {
        title: title,
        filterKey: "BRANDS",
        "data-testid": "brandsEcommFilter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                        className: "flex",
                        isDesktopEnabled: true,
                        children: Boolean(popularBrands.length) && popularBrands?.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_BrandListItem_BrandListItem, {
                                data: data,
                                type: "card"
                            }, data.name))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                        className: "-mx-16 mb-24 flex px-16 pb-8 pt-24",
                        isDesktopEnabled: true,
                        children: Boolean(brandGroups) && brandGroupsKeys.map((letter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                className: "relative mr-32 cursor-pointer whitespace-nowrap before:absolute before:-inset-16 before:content-['']",
                                tag: "div",
                                role: "button",
                                tabIndex: 0,
                                onClick: ()=>handleLetterClick(letter),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    message: String(letter),
                                    style: "h7",
                                    color: activeGroupLetter === letter ? "gold-50" : "black"
                                }, letter)
                            }, letter))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)(isMobile ? "" : "-mx-40 mt-24 px-20"),
                        role: "group",
                        children: brandGroups[activeGroupLetter]?.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_BrandListItem_BrandListItem, {
                                data: data,
                                type: "row"
                            }, data.id))
                    })
                ]
            })
        })
    });
};
/* harmony default export */ const BrandsFilter_BrandsFilter = (BrandsFilter);

// EXTERNAL MODULE: ./local_modules/formular/useField.ts
var useField = __webpack_require__(98917);
// EXTERNAL MODULE: ./src/helpers/modifiers/getTestIdFromText.ts
var getTestIdFromText = __webpack_require__(40638);
// EXTERNAL MODULE: ./src/components/inputs/Switch/Switch.tsx + 1 modules
var Switch = __webpack_require__(20299);
;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FilterSwitch/messages.ts
/* harmony default export */ const FilterSwitch_messages = ({
    GWP: {
        en: "Gift with purchase"
    },
    SALE: {
        en: "Sale! Up to 50% off"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FilterSwitch/FilterSwitch.tsx










const FilterSwitch_FILTER_KEY_MAP = {
    GWP: "gwp",
    SALE: "sale"
};
const FilterSwitch = (props)=>{
    const { filterKey } = props;
    const searchParamsKey = FilterSwitch_FILTER_KEY_MAP[filterKey];
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [searchParams, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const isSwitchEnabled = Boolean(searchParams?.[searchParamsKey]);
    const title = FilterSwitch_messages[filterKey];
    const field = (0,useField/* default */.Z)({
        value: isSwitchEnabled
    });
    (0,react.useEffect)(()=>{
        if (field.state.value !== isSwitchEnabled) {
            field.set(isSwitchEnabled);
        }
    }, [
        field,
        isSwitchEnabled
    ]);
    const handleChange = (0,react.useCallback)((value)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                [searchParamsKey]: value || undefined
            }), false, false);
    }, [
        searchParamsKey,
        setSearchParams
    ]);
    const bgClassName = (0,clsx/* default */.Z)("absolute -z-1 h-full bg-light-beige", isMobile ? "-inset-x-16" : "-inset-x-40");
    const switchClassName = (0,clsx/* default */.Z)("relative z-0 flex h-56 w-full cursor-pointer items-center justify-between");
    const testId = (0,getTestIdFromText/* default */.Z)(filterKey.toLowerCase(), "ecommFilter");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z.Group, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z.Label, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: switchClassName,
                "data-testid": testId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: bgClassName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "t5",
                        color: "gold-70",
                        message: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                        style: "gold",
                        field: field,
                        size: 30,
                        onChange: handleChange
                    })
                ]
            })
        })
    });
};
/* harmony default export */ const FilterSwitch_FilterSwitch = (FilterSwitch);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FilterWithValues/messages.ts
/* harmony default export */ const FilterWithValues_messages = ({
    FULL_BOTTLE_TYPES: {
        en: "Filter by type {quantity}"
    },
    SIZES: {
        en: "Filter by size {quantity}"
    },
    PRICE: {
        en: "Filter by price {quantity}"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FilterWithValues/FilterWithValues.tsx










const FilterWithValues = (param)=>{
    let { filterKey } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [_, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { appliedFilters, availableFilters } = (0,context/* useCatalogueContext */.J)();
    const appliedFilterIds = appliedFilters?.[filterKey];
    const availableItems = availableFilters?.[filterKey]?.values;
    const handleClick = (0,react.useCallback)((id)=>{
        const isFilterIdActive = appliedFilterIds?.includes(id);
        setSearchParams((prevParams)=>({
                ...prevParams,
                [availableFilters?.[filterKey]?.id]: !isFilterIdActive ? id : undefined
            }), false, false);
    }, [
        appliedFilterIds,
        availableFilters,
        filterKey,
        setSearchParams
    ]);
    const title = {
        ...FilterWithValues_messages[filterKey],
        values: {
            quantity: appliedFilterIds?.length > 0 ? `(${appliedFilterIds?.length})` : ""
        }
    };
    if (!availableItems) {
        return null;
    }
    const testId = (0,getTestIdFromText/* default */.Z)(filterKey.toLocaleLowerCase(), "ecommFilter");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDisclosure_FilterDisclosure, {
        title: title,
        filterKey: filterKey,
        "data-testid": testId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)(!isMobile && "-mx-40 px-20"),
            children: availableItems.map((param)=>{
                let { id, name } = param;
                const isActiveFilterItem = appliedFilterIds?.includes(id);
                const htmlAttrs = {
                    role: "checkbox",
                    "aria-checked": isActiveFilterItem
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RowListItemView_RowListItemView, {
                    title: name,
                    isActive: isActiveFilterItem,
                    ...htmlAttrs,
                    onClick: ()=>handleClick(id)
                }, name);
            })
        })
    });
};
/* harmony default export */ const FilterWithValues_FilterWithValues = (FilterWithValues);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FiltersActionButtons/messages.ts
/* harmony default export */ const FiltersActionButtons_messages = ({
    primaryButton: {
        en: `
      Show <span class="text-gold-30" data-testid="count">{count}</span>
      {productType, select, perfume {perfume} cologne {cologne} other {product}}
      {count, plural, one {result} other {results}}
    `
    },
    clearAll: {
        en: "Clear all"
    },
    emptyNote: {
        en: "We couldn't find anything in our catalog that matches your selections. Please try editing your search."
    },
    tooMuchBrands: {
        en: "Please edit your search down to eight brands or less, and try\xa0again."
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FiltersActionButtons/FiltersActionButtons.tsx











const DEFAULT_FILTER_KEYS = [
    "BRANDS",
    "NOTES",
    "TAGS",
    "PRICES",
    "SIZES",
    "FULL_BOTTLE_TYPES"
];
const FiltersActionButtons = (props)=>{
    const { filterKeys = DEFAULT_FILTER_KEYS, onApply } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const pathname = (0,contexts/* usePathname */.jD)();
    const [, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { availableFilters, appliedFilters, count, isFetchingProducts, appliedFiltersCount } = (0,context/* useCatalogueContext */.J)();
    const { targetParams, targetCount } = filterKeys.reduce((acc, filterKey)=>{
        if (appliedFilters?.[filterKey]) {
            acc.targetCount += appliedFilters?.[filterKey]?.length || 0;
            acc.targetParams[filterKey] = appliedFilters?.[filterKey];
        }
        return acc;
    }, {
        targetParams: {},
        targetCount: 0
    });
    const types = filterKeys.map((filterKey)=>availableFilters?.[filterKey]?.id);
    const prevParamsRef = (0,react.useRef)(targetParams);
    const handleClearAll = ()=>{
        (0,analytics/* track */.j)("Filter clear all", {});
        const nextParams = types.reduce((acc, type)=>{
            acc[type] = undefined;
            return acc;
        }, {});
        setSearchParams((prevParams)=>({
                ...prevParams,
                ...nextParams,
                gwp: undefined,
                sale: undefined
            }), false, false);
    };
    const handleApply = ()=>{
        if (!isFetchingProducts && appliedFiltersCount > 0 && count === 0) {
            (0,analytics/* track */.j)("Filter zero result display", {
                flow: "Applied by user"
            });
        }
        (0,analytics/* track */.j)("Filter apply", {
            notes: appliedFilters?.NOTES,
            productBrands: appliedFilters?.BRANDS,
            tagNames: appliedFilters?.TAGS?.map((id)=>{
                const item = availableFilters.TAGS?.values.find((item)=>id === item.id);
                return item?.name || id;
            })
        });
        onApply();
    };
    const isPrimaryButtonVisible = (0,react.useRef)(false);
    const isClearAllButtonVisible = targetCount > 0;
    if (!isPrimaryButtonVisible.current && targetParams !== prevParamsRef.current) {
        isPrimaryButtonVisible.current = true;
    }
    if (!isPrimaryButtonVisible.current && !isClearAllButtonVisible) {
        return null;
    }
    let noteMessage;
    if (targetParams?.["BRANDS"]?.length > 8) {
        noteMessage = FiltersActionButtons_messages.tooMuchBrands;
    } else if (!isFetchingProducts && count === 0) {
        noteMessage = FiltersActionButtons_messages.emptyNote;
    }
    const productType = pathname === links/* default */.ZP.subscription.perfumes ? "perfume" : pathname === links/* default */.ZP.subscription.colognes ? "cologne" : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("sticky bottom-0 my-0 flex flex-1 flex-col justify-end bg-white pb-16 pt-8", isMobile ? "-mx-16 px-16" : "-mx-40 px-40"),
        children: [
            Boolean(noteMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-8 text-center",
                message: noteMessage,
                style: "p4",
                color: "gold-70"
            }),
            isPrimaryButtonVisible.current && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: {
                    ...FiltersActionButtons_messages.primaryButton,
                    values: {
                        productType,
                        count: count || 0
                    }
                },
                size: 56,
                style: "primary",
                loading: isFetchingProducts,
                fullWidth: true,
                html: true,
                onClick: handleApply,
                "data-testid": "applyButton"
            }),
            isClearAllButtonVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: isPrimaryButtonVisible.current ? "mt-8" : null,
                title: FiltersActionButtons_messages.clearAll,
                size: 56,
                style: "tertiary",
                fullWidth: true,
                onClick: handleClearAll,
                "data-testid": "clearButton"
            })
        ]
    });
};
/* harmony default export */ const FiltersActionButtons_FiltersActionButtons = (FiltersActionButtons);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/components/FilterDisclosureGroup/FilterDisclosureGroup.tsx


const FilterDisclosureGroupContext = /*#__PURE__*/ (0,react.createContext)({
    openDisclosure: ()=>{}
});
const FilterDisclosureGroup = (props)=>{
    const { defaultValue, children } = props;
    const [openedDisclosure, openDisclosure] = (0,react.useState)(defaultValue);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDisclosureGroupContext.Provider, {
        value: {
            openedDisclosure,
            openDisclosure
        },
        children: children
    });
};
/* harmony default export */ const FilterDisclosureGroup_FilterDisclosureGroup = (FilterDisclosureGroup);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/messages.ts
/* harmony default export */ const EcommerceFiltersModal_messages = ({
    title: {
        en: "Filters"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/EcommerceFiltersModal/EcommerceFiltersModal.tsx


















const FILTERS_KEYS = [
    "BRANDS",
    "NOTES",
    "PRICE",
    "SIZES",
    "FULL_BOTTLE_TYPES"
];
const EcommerceFiltersModal = (props)=>{
    const { closeModal, showGwpFilter = true, showSaleFilter = true } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [searchParams] = (0,contexts/* useSearchParams */.lr)();
    const { availableFilters, appliedFiltersCount, scrollToFilters } = (0,context/* useCatalogueContext */.J)();
    const isGwpSpecificSkuEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.gwpSpecificSku);
    const isSaleEcommerceFilterEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.saleEcommerceFilter);
    const handleApply = (0,react.useCallback)(()=>{
        closeModal();
        scrollToFilters();
    }, [
        closeModal,
        scrollToFilters
    ]);
    const filtersList = (0,react.useMemo)(()=>{
        let enabledFiltersList = FILTERS_KEYS.filter((filterKey)=>Boolean(availableFilters?.[filterKey]));
        enabledFiltersList.sort((a, b)=>{
            return searchParams?.[availableFilters?.[a]?.id] && !searchParams?.[availableFilters?.[b]?.id] ? -1 : 1;
        });
        return enabledFiltersList.map((filterKey)=>{
            if (filterKey === "BRANDS") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsFilter_BrandsFilter, {}, filterKey);
            }
            if (filterKey === "NOTES") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesFilter_NotesFilter, {}, filterKey);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterWithValues_FilterWithValues, {
                filterKey: filterKey
            }, filterKey);
        });
    }, [
        availableFilters
    ]);
    const gwpFilterVisible = isGwpSpecificSkuEnabled && showGwpFilter;
    const saleFilterVisible = isSaleEcommerceFilterEnabled && showSaleFilter;
    const showSwitchFilters = gwpFilterVisible || saleFilterVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlainModal/* default */.ZP, {
        type: isMobile ? "sidebar-left" : "sidebar-right",
        bgColor: "white",
        closeModal: closeModal,
        "data-testid": "filtersModal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: appliedFiltersCount ? "mb-16" : "mb-24",
                message: EcommerceFiltersModal_messages.title,
                style: "sh5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFiltersList_ActiveFiltersList, {
                    className: "mb-12"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDisclosureGroup_FilterDisclosureGroup, {
                children: filtersList
            }),
            showSwitchFilters && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-32",
                "data-testid": "ecommBooleanFilters",
                children: [
                    gwpFilterVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSwitch_FilterSwitch, {
                        filterKey: "GWP"
                    }),
                    saleFilterVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSwitch_FilterSwitch, {
                        filterKey: "SALE"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersActionButtons_FiltersActionButtons, {
                onApply: handleApply
            })
        ]
    });
};
/* harmony default export */ const EcommerceFiltersModal_EcommerceFiltersModal = ((0,standaloneModal/* default */.Z)("ecommerceFiltersModal", EcommerceFiltersModal));

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/SortingModal/components/RowListItemView/RowListItemView.tsx






const components_RowListItemView_RowListItemView_RowListItemView = (props)=>{
    const { title, isActive, onClick, ...rest } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const activeItemClassName = isActive && (0,clsx/* default */.Z)("before:absolute before:-z-1 before:h-full before:bg-light-beige before:content-['']", isMobile ? "before:-inset-x-16" : "before:-inset-x-40");
    const rootClassName = (0,clsx/* default */.Z)("relative z-0 flex h-56 w-full cursor-pointer items-center justify-between desktop-hover:text-gold-50", isActive ? activeItemClassName : null);
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: rootClassName,
        type: "button",
        ...htmlAttrs,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: "p2"
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "24/checkmark",
                color: "gold-50"
            })
        ]
    });
};
/* harmony default export */ const SortingModal_components_RowListItemView_RowListItemView = (components_RowListItemView_RowListItemView_RowListItemView);

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/SortingModal/messages.ts
/* harmony default export */ const SortingModal_messages = ({
    title: {
        en: "Sort results"
    },
    sort: {
        DEFAULT: "By default",
        PRICE_ASC: {
            en: "By price, low to high"
        },
        PRICE_DESC: {
            en: "By price, high to low"
        },
        RATING_DESC: {
            en: "By rating, high to low"
        },
        NEW_ARRIVALS_DESC: {
            en: "New arrivals, new to old"
        }
    },
    button: {
        DEFAULT: "Sort",
        PRICE_ASC: {
            en: "Sort by price, low to high"
        },
        PRICE_DESC: {
            en: "Sort by price, high to low"
        },
        RATING_DESC: {
            en: "Sort by rating, high to low"
        },
        NEW_ARRIVALS_DESC: {
            en: "Sort by new arrivals, new to old"
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/components/SortingModal/SortingModal.tsx












// TODO: Move to the backend available sort — added on 22–09–2023 by algeas
const sortTypes = [
    "DEFAULT",
    "PRICE_ASC",
    "PRICE_DESC",
    "RATING_DESC",
    "NEW_ARRIVALS_DESC"
];
const SortingModal = (param)=>{
    let { closeModal } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [searchParams, setSearchParams] = (0,contexts/* useSearchParams */.lr)();
    const { scrollToFilters } = (0,context/* useCatalogueContext */.J)();
    const selectedSortType = searchParams?.sort || "DEFAULT";
    const handleClick = (0,react.useCallback)((sortType)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                sort: sortType === "DEFAULT" ? undefined : sortType
            }), false, false);
    }, [
        setSearchParams
    ]);
    const handleApply = (0,react.useCallback)(()=>{
        closeModal();
        scrollToFilters();
    }, [
        closeModal,
        scrollToFilters
    ]);
    const buttonMessage = SortingModal_messages.button[selectedSortType] || SortingModal_messages.button.DEFAULT;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlainModal/* default */.ZP, {
        type: isMobile ? "sidebar-left" : "sidebar-right",
        bgColor: "white",
        closeModal: closeModal,
        "data-testid": "filtersModal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-24",
                message: SortingModal_messages.title,
                style: "sh5"
            }),
            sortTypes.map((sortType)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SortingModal_components_RowListItemView_RowListItemView, {
                    title: SortingModal_messages.sort[sortType],
                    isActive: selectedSortType === sortType,
                    onClick: ()=>handleClick(sortType),
                    "data-testid": (0,getTestIdFromText/* default */.Z)(sortType.toLowerCase(), "EcommSort")
                }, sortType)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-1 flex-col justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    size: 56,
                    title: buttonMessage,
                    type: "primary",
                    onClick: handleApply,
                    "data-testid": "applyButton"
                })
            })
        ]
    });
};
/* harmony default export */ const SortingModal_SortingModal = ((0,standaloneModal/* default */.Z)("sortingModal", SortingModal));

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/messages.ts
/* harmony default export */ const Filters_messages = ({
    filters: {
        en: "Filter"
    },
    or: {
        en: "or"
    },
    personalize: {
        en: "Personalize"
    },
    sort: {
        en: "Sort"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/Filters/Filters.tsx
















const Filters = (props)=>{
    const { className, withSort, isEcommerce, showGwpFilter, showSaleFilter } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { availableFilters } = (0,context/* useCatalogueContext */.J)();
    const isEcommerceTwoZeroEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.ecommerceTwoZero);
    const isSortEnabled = withSort && isEcommerceTwoZeroEnabled;
    const isEcommerceVersionEnabled = isEcommerce && isEcommerceTwoZeroEnabled;
    const withPersonalize = Boolean(availableFilters?.TAGS);
    const filterButtonClassName = (0,clsx/* default */.Z)("flex-1", isSortEnabled ? isMobile ? "min-w-[112rem]" : "min-w-[176rem]" : "min-w-[168rem]");
    const sortButtonClassName = (0,clsx/* default */.Z)("ml-8 flex-1", isMobile ? "min-w-[112rem]" : "min-w-[176rem]");
    const personalizeButtonClassName = (0,clsx/* default */.Z)("flex-1", isEcommerceTwoZeroEnabled && "ml-8", isSortEnabled ? (0,clsx/* default */.Z)(isMobile ? "min-w-[144rem]" : "min-w-[176rem]") : "min-w-[168rem]");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex items-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton_FilterButton, {
                className: filterButtonClassName,
                title: Filters_messages.filters,
                iconName: "32/filters",
                "data-testid": "openFilterButton",
                onClick: ()=>{
                    (0,analytics/* track */.j)("Filter button click");
                    if (isEcommerceVersionEnabled) {
                        (0,manager/* openModal */.h7)("ecommerceFiltersModal", {
                            showGwpFilter,
                            showSaleFilter
                        });
                    } else {
                        (0,manager/* openModal */.h7)("filtersModal");
                    }
                }
            }),
            withPersonalize && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !isEcommerceVersionEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "mx-8 flex-none",
                        message: Filters_messages.or,
                        style: "p2",
                        color: "gray-80"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton_FilterButton, {
                        className: personalizeButtonClassName,
                        title: Filters_messages.personalize,
                        iconName: "32/personalize",
                        "data-testid": "openPersonalizeButton",
                        onClick: ()=>{
                            (0,analytics/* track */.j)("Personalize button click");
                            (0,manager/* openModal */.h7)("personalityTagsModal", {
                                keepSortAndFilters: isEcommerce
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalityTagsModal_PersonalityTagsModal, {})
                ]
            }),
            isSortEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton_FilterButton, {
                className: sortButtonClassName,
                title: Filters_messages.sort,
                iconName: "32/arrow-down",
                "data-testid": "openSortButton",
                onClick: ()=>{
                    (0,analytics/* track */.j)("Filter button click");
                    (0,manager/* openModal */.h7)("sortingModal");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortingModal_SortingModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersModal_FiltersModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EcommerceFiltersModal_EcommerceFiltersModal, {})
        ]
    });
};
/* harmony default export */ const Filters_Filters = (/*#__PURE__*/react.memo(Filters));

// EXTERNAL MODULE: ./local_modules/intersection-observer/useSticky.ts
var useSticky = __webpack_require__(73302);
// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntryListener.ts + 1 modules
var useEntryListener = __webpack_require__(36191);
;// CONCATENATED MODULE: ./src/pages/catalog/components/MobileStickyTopContainer/MobileStickyTopContainer.tsx



// TODO move to common components? - added on 21.09.2021 by sonatskiy
const MobileStickyTopContainer = (param)=>{
    let { id, stickyClassName, children } = param;
    const stickyClass = `${stickyClassName || ""} fixed left-0 top-0 w-full z-floating-header`.split(" ").filter(Boolean);
    const [containerRef, headerRef, setSticky] = (0,useSticky/* default */.Z)({
        stickyClass
    });
    const [triggerRef] = (0,useEntryListener/* default */.Z)((entry)=>{
        setSticky(entry.boundingClientRect.top < 0);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: triggerRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: containerRef,
                id: id,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: headerRef,
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ const MobileStickyTopContainer_MobileStickyTopContainer = (MobileStickyTopContainer);

;// CONCATENATED MODULE: ./src/pages/catalog/components/FiltersSection/FiltersSection.tsx









const FiltersSection = (props)=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { className, countMessage, isFetching, withSort = false, isEcommerce = false, showGwpFilter, showSaleFilter } = props;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileStickyTopContainer_MobileStickyTopContainer, {
            id: "catalogueFilters",
            stickyClassName: "group shadow is-sticky",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                className: (0,clsx/* default */.Z)(className, "bg-white py-16"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_Filters, {
                        withSort: withSort,
                        isEcommerce: isEcommerce,
                        showGwpFilter: showGwpFilter,
                        showSaleFilter: showSaleFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)("mt-16 group-[.is-sticky]:hidden"),
                        children: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                            w: 200,
                            h: 20
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: countMessage,
                            style: "sh6",
                            color: "gold-70",
                            html: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFiltersList_ActiveFiltersList, {
                        className: "mt-8 group-[.is-sticky]:-mb-4 group-[.is-sticky]:mt-12"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        id: "catalogueFilters",
        className: (0,clsx/* default */.Z)(className, "flex items-center justify-between"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 overflow-hidden",
                children: [
                    isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                        w: 274,
                        h: 27
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: countMessage,
                        style: "sh4",
                        color: "gold-70",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFiltersList_ActiveFiltersList, {
                        className: "mt-8"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_Filters, {
                className: "flex-none",
                withSort: withSort,
                isEcommerce: isEcommerce,
                showGwpFilter: showGwpFilter,
                showSaleFilter: showSaleFilter
            })
        ]
    });
};
/* harmony default export */ const FiltersSection_FiltersSection = (FiltersSection);


/***/ }),

/***/ 13985:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ FragranceTabsHeader_FragranceTabsHeader)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/navigation/Tabs/Tabs.tsx + 4 modules
var Tabs = __webpack_require__(22958);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/pages/catalog/components/HeadlineTab/HeadlineTab.tsx





const HeadlineTab = (param)=>{
    let { title, to, isActive } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const className = isActive ? (0,clsx/* default */.Z)("text-gold-50", !isMobile && "underline cursor-default pointer-events-none underline-offset-[8rem] decoration-[3rem]") : (0,clsx/* default */.Z)("cursor-pointer text-black", !isMobile && "no-underline underline-offset-[8rem] decoration-[3rem] desktop-hover:underline");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
        message: title,
        className: className,
        to: to
    });
};
/* harmony default export */ const HeadlineTab_HeadlineTab = (/*#__PURE__*/react.memo(HeadlineTab));

// EXTERNAL MODULE: ./src/pages/catalog/components/PageTitle/PageTitle.tsx
var PageTitle = __webpack_require__(72462);
;// CONCATENATED MODULE: ./src/pages/catalog/components/FragranceTabsHeader/messages.ts
/* harmony default export */ const messages = ({
    perfumes: {
        en: "Perfumes"
    },
    colognes: {
        en: "Colognes"
    },
    or: {
        en: "or"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/FragranceTabsHeader/FragranceTabsHeader.tsx












const FragranceTabsHeader = (props)=>{
    const { mobileTitle, desktopTitlePrefix, description, perfumesLink, colognesLink } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const history = (0,contexts/* useHistory */.k6)();
    const pathname = (0,contexts/* usePathname */.jD)();
    const intl = (0,useIntl/* default */.Z)();
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                    title: mobileTitle,
                    description: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                    className: "mt-32",
                    defaultActiveTab: pathname,
                    justify: "justify-around",
                    onChange: (id)=>history.push(id),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z.Content, {
                            id: perfumesLink,
                            title: messages.perfumes
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z.Content, {
                            id: colognesLink,
                            title: messages.colognes
                        })
                    ]
                }, pathname)
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                className: "flex items-baseline justify-start",
                style: "h4",
                withInnerLinksStyling: false,
                children: [
                    intl.formatMessage(desktopTitlePrefix),
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineTab_HeadlineTab, {
                        title: messages.perfumes,
                        to: perfumesLink,
                        isActive: pathname === perfumesLink
                    }),
                    "\xa0",
                    intl.formatMessage(messages.or),
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineTab_HeadlineTab, {
                        title: messages.colognes,
                        to: colognesLink,
                        isActive: pathname === colognesLink
                    })
                ]
            }),
            Boolean(description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24",
                message: description,
                style: "p2",
                html: true
            })
        ]
    });
};
/* harmony default export */ const FragranceTabsHeader_FragranceTabsHeader = (/*#__PURE__*/react.memo(FragranceTabsHeader));


/***/ }),

/***/ 72462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24113);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31627);





const PageTitle = (props)=>{
    const { title, description } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                message: title,
                style: isMobile ? "sh3" : "h4"
            }),
            Boolean(description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "mt-16",
                message: description,
                style: "p2",
                html: true
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PageTitle);


/***/ }),

/***/ 50824:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductFeed_ProductFeed)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/compositions/InfinityScrollProductFeed/InfinityScrollProductFeed.tsx + 7 modules
var InfinityScrollProductFeed = __webpack_require__(33890);
// EXTERNAL MODULE: ./src/pages/catalog/util/context.ts
var context = __webpack_require__(63985);
// EXTERNAL MODULE: ./src/pages/catalog/components/FiltersSection/FiltersSection.tsx + 56 modules
var FiltersSection = __webpack_require__(68575);
;// CONCATENATED MODULE: ./src/pages/catalog/components/ProductFeed/messages.ts
/* harmony default export */ const messages = ({
    matchesProductCount: {
        en: '<span data-testid="productsCount">{count}</span> {count, plural, one {product match} other {product matches}}'
    },
    defaultProductCount: {
        en: 'Now browsing <span data-testid="productsCount">{count}</span> products'
    },
    matchesFragranceCount: {
        en: '<span data-testid="productsCount">{count}</span> {count, plural, one {fragrance match} other {fragrance matches}}'
    },
    defaultFragranceCount: {
        en: 'Now browsing <span data-testid="productsCount">{count}</span> {isMale, select, true {colognes} false {perfumes}}'
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/ProductFeed/ProductFeed.tsx












const metadata = {
    placement: "Feed"
};
const limit = 24;
const ProductFeed = (props)=>{
    const { injectBanners, injectFeedBanners, filtersClassName, withFilters = false, isFragrance = false, isMale = false, hideWithoutTradingItems = false, filterByVolume, withEcommercePrefix, withSort = false, isEcommerceFilters = false, withForwardedTradingItemId = false, showGwpFilter, showSaleFilter } = props;
    const { previousUrl } = (0,contexts/* useLocationState */.KJ)();
    const isEcommerceTwoZeroEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.ecommerceTwoZero);
    const { products, isFetchingFilters, isFetchingProducts, isEcommerce, isExtras, count, fetchMore, appliedFiltersCount } = (0,context/* useCatalogueContext */.J)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { visibleProducts, visibleProductsAmount, totalCount } = (0,react.useMemo)(()=>{
        let productsList = hideWithoutTradingItems ? products?.filter((param)=>{
            let { tradingItems } = param;
            return Boolean(tradingItems.items.length);
        }) : products;
        if (productsList?.length && filterByVolume) {
            productsList = productsList.reduce((result, product)=>{
                const filteredTradingItems = product?.tradingItems?.items?.filter((param)=>{
                    let { volume } = param;
                    return volume.volume === filterByVolume.volume && volume.unit === filterByVolume.unit;
                });
                if (filteredTradingItems.length) {
                    result.push({
                        ...product,
                        tradingItems: {
                            items: filteredTradingItems
                        }
                    });
                }
                return result;
            }, []);
        }
        // inject feed banners
        let list = productsList;
        // we count before injecting banners
        const visibleProductsAmount = productsList?.length || 0;
        const totalCount = count - (products?.length - productsList?.length);
        const hasMore = totalCount - visibleProductsAmount;
        if (list?.length && injectFeedBanners?.length) {
            injectFeedBanners.forEach((param)=>{
                let { node, index } = param;
                // don't add to the end
                if (index >= productsList.length) {
                    return;
                }
                list.splice(index, 0, node);
                if (hasMore) {
                    // remove last item to compensate banner during loading
                    list.splice(list.length - 1, 1);
                }
            });
        }
        return {
            visibleProducts: list,
            visibleProductsAmount,
            totalCount
        };
    }, [
        count,
        products,
        hideWithoutTradingItems,
        filterByVolume,
        injectFeedBanners
    ]);
    // TODO: Remove after backend implement server-side filter — added on 05–10–2022 by algeas
    const countMessage = withFilters ? {
        ...appliedFiltersCount > 0 ? isFragrance ? messages.matchesFragranceCount : messages.matchesProductCount : isFragrance ? messages.defaultFragranceCount : messages.defaultProductCount,
        values: {
            count: totalCount || "",
            isMale
        }
    } : null;
    const restProductsAmount = count - visibleProductsAmount;
    const fetchMoreSkeletonsAmount = restProductsAmount > limit ? limit : restProductsAmount;
    (0,react.useEffect)(()=>{
        if (!previousUrl && withFilters && !isFetchingProducts && appliedFiltersCount > 0 && count === 0) {
            (0,analytics/* track */.j)("Filter zero result display", {
                flow: "Direct link"
            });
        }
    }, [
        appliedFiltersCount,
        count,
        isFetchingProducts,
        withFilters,
        previousUrl
    ]);
    const isFetching = isFetchingFilters || isFetchingProducts;
    const filterSectionClassName = filtersClassName || (isMobile ? null : "mt-48");
    const isFiltersVisible = withFilters && (!isEcommerceFilters || isEcommerceTwoZeroEnabled);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isFiltersVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersSection/* default */.Z, {
                className: filterSectionClassName,
                countMessage: countMessage,
                isFetching: isFetching,
                withSort: withSort,
                isEcommerce: isEcommerceFilters,
                showGwpFilter: showGwpFilter,
                showSaleFilter: showSaleFilter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfinityScrollProductFeed/* default */.Z, {
                className: isMobile ? isFiltersVisible ? null : "mt-16" : isFiltersVisible ? "mt-16" : "mt-48",
                products: visibleProducts,
                metadata: metadata,
                injectBanners: injectBanners,
                totalCount: totalCount,
                fetchMore: fetchMore,
                fetchSkeletonsAmount: fetchMoreSkeletonsAmount,
                isEcommerce: isEcommerce || isExtras,
                withEcommercePrefix: withEcommercePrefix,
                withForwardedTradingItemId: withForwardedTradingItemId,
                isFetching: isFetching
            })
        ]
    });
};
/* harmony default export */ const ProductFeed_ProductFeed = (ProductFeed);


/***/ }),

/***/ 8859:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69541);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66226);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84584);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1869);
/* harmony import */ var compositions_blocks_UpgradeLargeBlock_UpgradeLargeBlock__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82527);








const UpgradeFeedBanner = ()=>{
    const { productsPerPeriodPlans, isFetching } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_3__/* .useUpgradePlans */ .V_)();
    const history = (0,router__WEBPACK_IMPORTED_MODULE_4__/* .useHistory */ .k6)();
    const onPlanSelect = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((plan)=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_5__/* .track */ .j)("Upgrade new subscription plan click", {
            newSubscriptionPlan: plan.name
        });
    }, []);
    const onConfirm = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        history.push(links__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP.profile.subscriptionStatus);
    }, [
        history
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(compositions_blocks_UpgradeLargeBlock_UpgradeLargeBlock__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: "my-40",
        plans: productsPerPeriodPlans,
        isFetching: isFetching,
        fullWidth: true,
        onPlanSelect: onPlanSelect,
        onConfirm: onConfirm
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UpgradeFeedBanner);


/***/ }),

/***/ 30547:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ tagGroupNamesOrder)
/* harmony export */ });
const tagGroupNamesOrder = [
    "Scent type",
    "Occasion",
    "Personality",
    "Fragrance family",
    "Season",
    "Complexity"
];


/***/ }),

/***/ 63985:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: () => (/* binding */ useCatalogueContext),
/* harmony export */   N: () => (/* binding */ CatalogueContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const CatalogueContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useCatalogueContext = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CatalogueContext);


/***/ }),

/***/ 31776:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84584);

const useFragranceCatalogueName = (param)=>{
    let { colognesLink } = param;
    const pathname = (0,router__WEBPACK_IMPORTED_MODULE_0__/* .usePathname */ .jD)();
    const isMale = pathname === colognesLink;
    const catalogueName = isMale ? "colognes" : "perfumes";
    return {
        isMale,
        catalogueName
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFragranceCatalogueName);


/***/ }),

/***/ 57434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ util_useFragranceTagGroups)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/pages/catalog/util/constants.ts
var constants = __webpack_require__(30547);
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/fragrance-family-desktop.jpg
const fragrance_family_desktop_namespaceObject = __webpack_require__.p + "images/fragrance-family-desktop_b79ade.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/fragrance-family-mobile.jpg
const fragrance_family_mobile_namespaceObject = __webpack_require__.p + "images/fragrance-family-mobile_05d587.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/occasion-desktop.jpg
const occasion_desktop_namespaceObject = __webpack_require__.p + "images/occasion-desktop_ee0673.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/occasion-mobile.jpg
const occasion_mobile_namespaceObject = __webpack_require__.p + "images/occasion-mobile_3b88e7.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/personality-desktop.jpg
const personality_desktop_namespaceObject = __webpack_require__.p + "images/personality-desktop_744197.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/personality-mobile.jpg
const personality_mobile_namespaceObject = __webpack_require__.p + "images/personality-mobile_38aff8.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/scent-type-desktop.jpg
const scent_type_desktop_namespaceObject = __webpack_require__.p + "images/scent-type-desktop_60e4c0.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/scent-type-mobile.jpg
const scent_type_mobile_namespaceObject = __webpack_require__.p + "images/scent-type-mobile_506d02.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/season-desktop.jpg
const season_desktop_namespaceObject = __webpack_require__.p + "images/season-desktop_31ab71.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/perfumes/season-mobile.jpg
const season_mobile_namespaceObject = __webpack_require__.p + "images/season-mobile_231c3c.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/colognes/fragrance-family-desktop.jpg
const colognes_fragrance_family_desktop_namespaceObject = __webpack_require__.p + "images/fragrance-family-desktop_02814d.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/colognes/fragrance-family-mobile.jpg
const colognes_fragrance_family_mobile_namespaceObject = __webpack_require__.p + "images/fragrance-family-mobile_bd62a5.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/colognes/occasion-desktop.jpg
const colognes_occasion_desktop_namespaceObject = __webpack_require__.p + "images/occasion-desktop_75d87b.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/colognes/occasion-mobile.jpg
const colognes_occasion_mobile_namespaceObject = __webpack_require__.p + "images/occasion-mobile_c4c79a.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/colognes/personality-desktop.jpg
const colognes_personality_desktop_namespaceObject = __webpack_require__.p + "images/personality-desktop_20398b.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/images/colognes/personality-mobile.jpg
const colognes_personality_mobile_namespaceObject = __webpack_require__.p + "images/personality-mobile_c41fdc.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/util/useFragranceTagGroups.ts




















const perfumesGroupImages = {
    "Fragrance family": {
        desktop: fragrance_family_desktop_namespaceObject,
        mobile: fragrance_family_mobile_namespaceObject
    },
    "Scent type": {
        desktop: scent_type_desktop_namespaceObject,
        mobile: scent_type_mobile_namespaceObject
    },
    "Occasion": {
        desktop: occasion_desktop_namespaceObject,
        mobile: occasion_mobile_namespaceObject
    },
    "Personality": {
        desktop: personality_desktop_namespaceObject,
        mobile: personality_mobile_namespaceObject
    },
    "Season": {
        desktop: season_desktop_namespaceObject,
        mobile: season_mobile_namespaceObject
    }
};
const colognesGroupImages = {
    "Fragrance family": {
        desktop: colognes_fragrance_family_desktop_namespaceObject,
        mobile: colognes_fragrance_family_mobile_namespaceObject
    },
    "Occasion": {
        desktop: colognes_occasion_desktop_namespaceObject,
        mobile: colognes_occasion_mobile_namespaceObject
    },
    "Personality": {
        desktop: colognes_personality_desktop_namespaceObject,
        mobile: colognes_personality_mobile_namespaceObject
    },
    "Season": {
        // the same image as for perfumes, so use only one
        desktop: season_desktop_namespaceObject,
        mobile: season_mobile_namespaceObject
    }
};
const groupImages = {
    perfumes: perfumesGroupImages,
    colognes: colognesGroupImages,
    shopSamplePerfumes: perfumesGroupImages,
    shopSampleColognes: colognesGroupImages,
    shopTravelSizePerfumes: perfumesGroupImages,
    shopTravelSizeColognes: colognesGroupImages,
    theShopPerfumes: perfumesGroupImages,
    theShopColognes: colognesGroupImages
};
const useFragranceTagGroups = (param)=>{
    let { availableTags, catalogueName } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const deviceType = isMobile ? "mobile" : "desktop";
    return (0,react.useMemo)(()=>{
        if (!availableTags) {
            return null;
        }
        const groupsMap = availableTags.values.reduce((result, item)=>{
            const name = item.group;
            const image = groupImages[catalogueName]?.[name]?.[deviceType] || item.rebrandImage || item.image;
            if (!result[name]) {
                result[name] = {
                    name,
                    items: [
                        item
                    ],
                    image
                };
            } else {
                result[name].items.push(item);
            // uncomment if there will be a decision to override image for group if current tag is active filter
            // if (appliedTagIds?.includes(item.id)) {
            //   result[name].image = image
            // }
            }
            return result;
        }, {});
        return constants/* tagGroupNamesOrder */.T.reduce((groups, name)=>{
            if (groupsMap[name]) {
                groups.push(groupsMap[name]);
            }
            return groups;
        }, []);
    }, [
        availableTags,
        catalogueName,
        deviceType
    ]);
};
/* harmony default export */ const util_useFragranceTagGroups = (useFragranceTagGroups);


/***/ })

}]);